/* eslint-disable prefer-destructuring */
/* eslint-disable no-lonely-if */
/* eslint-disable no-use-before-define */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-underscore-dangle */
import axios from 'axios';

import { setIsLoading, setIsConfigSaved, setSnackbar } from './common.duck';
import { dataURItoBlob } from '../utils/screenshotHelpers';
import {
  skuVariantMap,
  tshirtSkuVariantMap,
  orderJsonItemsHelmet,
  orderJsonItemsTshirt,
  tshirtBikeModelMap,
  tshirtBikeColorMap,
  tshirtPrintMap,
  tshirtBadgeMap,
  orderJsonItemsJacket,
  jacketSkuVariantMap,
  jacketSkuRainMap,
  jacketSkuWinterMap,
  jacketSkuArmourMap
} from '../utils/staticData';
import { availableHotspots } from '../utils/tshirtHotspots';
export const SET_ALERT_DIALOG = 'CUSTOMIZER/SET_ALERT_DIALOG';
export const SET_AVAILABLE_VARIANTS_DATA =
  'CUSTOMIZER/SET_AVAILABLE_VARIANTS_DATA';
export const UPDATE_PARTS_CONFIG = 'CUSTOMIZER/UPDATE_PARTS_CONFIG';
export const RESET_PARTS_CONFIG = 'CUSTOMIZER/RESET_PARTS_CONFIG';
export const REMOVE_PART_CONFIG = 'CUSTOMIZER/REMOVE_PART_CONFIG';
export const SET_SELECTED_CATEGORY = 'CUSTOMIZER/SET_SELECTED_CATEGORY';
export const SET_CURRENT_TEXT = 'CUSTOMIZER/SET_CURRENT_TEXT';
export const SET_AVAILABLE_CUSTOMIZATIONS =
  'CUSTOMIZER/SET_AVAILABLE_CUSTOMIZATIONS';
export const SET_AVAILABLE_CATEGORIES = 'CUSTOMIZER/SET_AVAILABLE_CATEGORIES';
export const POPULATE_ALL_PART_CONFIG = 'CUSTOMIZER/POPULATE_ALL_PART_CONFIG';
export const SET_VARIANT_DATA = 'CUSTOMIZER/SET_VARIANT_DATA';
export const SET_IS_DATA_READY = 'CUSTOMIZER/SET_IS_DATA_READY';
export const PUSH_TO_UNDO_STACK = 'CUSTOMIZER/PUSH_TO_UNDO_STACK';
export const PUSH_TO_REDO_STACK = 'CUSTOMIZER/PUSH_TO_REDO_STACK';
export const UNDO = 'CUSTOMIZER/UNDO';
export const REDO = 'CUSTOMIZER/REDO';
export const SET_SELECTED_SIZE = 'CUSTOMIZER/SET_SELECTED_SIZE';
export const SET_SELECTED_VARIANT = 'CUSTOMIZER/ SET_SELECTED_VARIANT';
export const SET_USER_ID = 'CUSTOMIZER/SET_USER_ID';
export const SET_SESSION_ID = 'CUSTOMIZER/SET_SESSION_ID';
export const SET_USER_CONFIG_ID = 'CUSTOMIZER/SET_USER_CONFIG_ID';
export const SET_ACTIVE_PARENT = 'CUSTOMIZER/SET_ACTIVE_PARENT';
export const SET_FRONT_BIKE_PLATE = 'CUSTOMIZER/SET_FRONT_BIKE_PLATE';
export const SET_BACK_BIKE_PLATE = 'CUSTOMIZER/SET_BACK_BIKE_PLATE';
export const SET_FRONT_BIKE_TEXT = 'CUSTOMIZER/SET_FRONT_BIKE_TEXT';
export const SET_BACK_BIKE_TEXT = 'CUSTOMIZER/SET_BACK_BIKE_TEXT';
export const SET_ACTIVE_HOTSPOT = 'CUSTOMIZER/SET_ACTIVE_HOTSPOT';
export const POPULATE_SAVED_USER_CONFIGS =
  'CUSTOMIZER/POPULATE_SAVED_USER_CONFIGS';
export const SET_SHOULD_REAPPLY_CUSTOMIZATION =
  'CUSTOMIZER/SET_SHOULD_REAPPLY_CUSTOMIZATIONS';
export const SET_SITE_URL = 'CUSTOMIZATIONS/SET_SITE_URL';
const UNDO_STACK_LIMIT = 2;

export const setAvailableVariants = (variant, data) => ({
  type: SET_AVAILABLE_VARIANTS_DATA,
  variant,
  data
});

export const setCurrentActiveParent = category => ({
  type: SET_ACTIVE_PARENT,
  category
});

export const setSelectedCategory = category => ({
  type: SET_SELECTED_CATEGORY,
  category
});

export const setSelectedVariant = variant => ({
  type: SET_SELECTED_VARIANT,
  variant
});

export const setSelectedSize = size => ({
  type: SET_SELECTED_SIZE,
  size
});

export const setHotspot = hotspot => ({
  type: SET_ACTIVE_HOTSPOT,
  hotspot
});

export const setAvailableCategories = data => ({
  type: SET_AVAILABLE_CATEGORIES,
  data
});

export const setAvailableCustomizations = data => ({
  type: SET_AVAILABLE_CUSTOMIZATIONS,
  data
});

export const updatePartsConfigForCategory = (
  data,
  category,
  ignoredList,
  isInitialLoad
) => ({
  type: UPDATE_PARTS_CONFIG,
  data,
  category,
  ignoredList,
  isInitialLoad
});

export const resetPartsConfig = () => ({
  type: RESET_PARTS_CONFIG,
  config: {}
});

export const setIsDataReady = bool => ({
  type: SET_IS_DATA_READY,
  bool
});

export const setShouldReapplyCustomization = data => ({
  type: SET_SHOULD_REAPPLY_CUSTOMIZATION,
  data
});

export const removePartConfig = category => ({
  type: REMOVE_PART_CONFIG,
  category
});
// update name
export const populateAllPartsConfig = data => ({
  type: POPULATE_ALL_PART_CONFIG,
  data
});
export const setCurrentText = (text, rotateTo) => ({
  type: SET_CURRENT_TEXT,
  text,
  rotateTo
});
export const setFrontBikeNumberPlate = (
  line,
  uOffset,
  vOffset,
  fontSize,
  width
) => ({
  type: SET_FRONT_BIKE_PLATE,
  line,
  uOffset,
  vOffset,
  fontSize,
  width
});
export const setBackBikeNumberPlate = (
  line,
  uOffset,
  vOffset,
  fontSize,
  width
) => ({
  type: SET_BACK_BIKE_PLATE,
  line,
  uOffset,
  vOffset,
  fontSize,
  width
});
export const setFrontBikeText = line => ({
  type: SET_FRONT_BIKE_TEXT,
  line
});
export const setBackBikeText = line => ({
  type: SET_BACK_BIKE_TEXT,
  line
});
export const setVariantData = data => ({
  type: SET_VARIANT_DATA,
  data
});
export const pushToUndoStack = data => ({
  type: PUSH_TO_UNDO_STACK,
  data
});
export const pushToRedoStack = data => ({
  type: PUSH_TO_REDO_STACK,
  data
});
export const undoChanges = () => ({
  type: UNDO
});
export const redoChanges = () => ({
  type: REDO
});
export const setUserId = userId => ({
  type: SET_USER_ID,
  userId
});
export const setSessionId = sessionId => ({
  type: SET_SESSION_ID,
  sessionId
});
export const setUserConfigId = userConfigId => ({
  type: SET_USER_CONFIG_ID,
  userConfigId
});
export const populateSavedUserConfigs = data => ({
  type: POPULATE_SAVED_USER_CONFIGS,
  data
});
export const openAlertDialog = alertInfo => {
  return {
    type: SET_ALERT_DIALOG,
    alertInfo
  };
};

export const closeAlertDialogBox = () => ({
  type: SET_ALERT_DIALOG,
  alertInfo: {
    isOpen: false
  }
});
export const clearAlertDialogData = () => ({
  type: SET_ALERT_DIALOG,
  alertInfo: {
    title: '',
    message: '',
    isDisagreeAvailable: true,
    agreeButtonText: 'Agree',
    disagreeButtonText: 'Disagree',
    onAgree: () => {},
    onDisagree: () => {}
  }
});
export const setSiteUrl = siteUrl => ({
  type: SET_SITE_URL,
  siteUrl
});
const initialState = {
  siteUrl: null,
  currentActiveParent: null,
  selectedVariant: '',
  selectedCategory: '',
  variantData: [],
  // all available variants for a particular accessory and available customization categories in them
  availableVariants: {},
  // all available customizable categories
  availableCategories: [],
  // all available customizations with category name as key and all data for that category as array value
  availableCustomizations: {},
  // the object that saves a map of all parts inside a category. Each customization has a unique part
  // The selected config parts are set to true, rest are all false
  partsConfig: {},
  // whitelist of all parts that have to exist,
  undoStack: [],
  redoStack: [],
  activeHotspot: null,
  currentSelection: {},
  currentText: [
    { line: '', fontSize: 20 },
    { line: '', fontSize: 14 }
  ],
  tShirtBikeFrontText: [
    {
      line: '',
      fontSize: 20,
      id: 'frontText',
      hAlign: 'center',
      vAlign: 'center'
    }
  ],
  tShirtBikeFrontNumberPlate: {
    text: [
      {
        line: '',
        fontSize: 14,
        id: 'frontNumerPlate',
        hAlign: 'center',
        vAlign: 'center'
      }
    ]
  },
  tShirtBikeBackNumberPlate: {
    text: [
      {
        line: '',
        fontSize: 14,
        id: 'backNumerPlate',
        hAlign: 'center',
        vAlign: 'center'
      }
    ]
  },
  tShirtBikeBackText: [
    {
      line: '',
      fontSize: 20,
      id: 'backText',
      hAlign: 'center',
      vAlign: 'center'
    }
  ],
  tShirtBackText: [
    {
      line: '',
      fontSize: 20,
      id: 'backText',
      hAlign: 'center',
      vAlign: 'center'
    }
  ],
  rotateTo: 'front',
  selectedSize: '',
  userConfigId: null,
  userId: null, // 'scapic',
  sessionId: '',
  savedUserConfigs: [],
  reapplyCustomization: {
    shouldApply: false,
    selectedPart: null
  },
  isDataReady: false, // bool to detect when data is populated
  alertInfo: {
    isOpen: false,
    title: '',
    message: '',
    isDisagreeAvailable: true,
    agreeButtonText: 'Agree',
    disagreeButtonText: 'Disagree',
    onAgree: () => {},
    onDisagree: () => {}
  }
};

/**
 * @summary takes in the saved partConfig(separated category-wise) and flattens it to one object
 * will be used to save the config, and to reflect changes in 3D sdk
 * @param {*} partConfig current data from redux
 */

export const flattenPartsConfiguration = (
  partsConfig,
  customizer,
  text,
  color
) => {
  let partVariation = {};
  let versions = {};
  Object.keys(partsConfig).forEach(key => {
    // change tshirt text color based on tshirt color
    let selectedTshirtColor = 'TCL006'; // anything to select white

    if (partsConfig.baseShirtColor) {
      selectedTshirtColor = Object.keys(partsConfig.baseShirtColor).find(
        partId => partsConfig.baseShirtColor[partId] === true
      );
    }

    const textColor =
      selectedTshirtColor === 'TCL001' ||
      selectedTshirtColor === 'TCL002' ||
      selectedTshirtColor === 'TCL004'
        ? '#fff'
        : '#000';

    if (key === 'finish') versions = { ...versions, ...partsConfig[key] };
    else if (key === 'text') {
      let textConfig = {};
      Object.keys(partsConfig.text).forEach(textId => {
        if (
          partsConfig.text[textId] === false ||
          !text
          // (text[0] === '' && text[1] === '')
        ) {
          textConfig = {
            ...textConfig,
            [textId]: false
          };
        } else {
          textConfig = {
            ...textConfig,
            [textId]: { text, color }
          };
        }
      });
      partVariation = { ...partVariation, ...textConfig };
    } else if (key === 'bikeArt' && customizer) {
      // let textConfig = {};
      // Object.keys(partsConfig.bikeArt).forEach(textId => {
      //   if (partsConfig.text[textId] === false) {
      //     textConfig = {
      //       ...textConfig,
      //       [textId]: false
      //     };
      //   } else {
      //     textConfig = {
      //       ...textConfig,
      //       [textId]: { text, color }
      //     };
      //   }
      // });
      let selectedFrontText = Object.keys(partsConfig.bikeArt).find(
        textId =>
          textId.match(/TXT\d{3}F/i) && partsConfig.bikeArt[textId] === true
      );

      let selectedBackText = Object.keys(partsConfig.bikeArt).find(
        textId =>
          textId.match(/TXT\d{3}B/i) && partsConfig.bikeArt[textId] === true
      );

      const selectedFrontNumberPlateText = Object.keys(
        partsConfig.bikeArt
      ).find(
        textId =>
          textId.match(/BN\d{4}F/i) && partsConfig.bikeArt[textId] === true
      );
      const selectedBackNumberPlateText = Object.keys(partsConfig.bikeArt).find(
        textId =>
          textId.match(/BN\d{4}B/i) && partsConfig.bikeArt[textId] === true
      );
      const textConfig = {};
      if (selectedFrontText) {
        if (!selectedFrontNumberPlateText && selectedFrontText === 'TXT001F') {
          textConfig[selectedFrontText] = false;
          selectedFrontText = 'TXT002F';
        }
        let textData = JSON.parse(
          JSON.stringify(customizer.tShirtBikeFrontText)
        );
        const partForData = customizer.availableCustomizations.bikeArt.find(
          x => x.partId === selectedFrontText
        );
        if (partForData && partForData.configData.fontSize) {
          textData[0].fontSize = partForData.configData.fontSize;
        }
        textConfig[selectedFrontText] = {
          text: textData,
          color: textColor,
          id: customizer.tShirtBikeFrontText[0].id,
          uOffset: 0.29
        };
        partVariation = {
          ...partVariation,
          ...partsConfig[key],
          ...textConfig
        };
      }
      if (selectedBackText) {
        if (!selectedBackNumberPlateText && selectedBackText === 'TXT001B') {
          textConfig[selectedBackText] = false;
          selectedBackText = 'TXT006B';
        }
        let textData = JSON.parse(
          JSON.stringify(customizer.tShirtBikeBackText)
        );
        const partForData = customizer.availableCustomizations.bikeArt.find(
          x => x.partId === selectedBackText
        );
        if (partForData && partForData.configData.fontSize) {
          textData[0].fontSize = 24;
        }

        textConfig[selectedBackText] = {
          text: textData, // customizer.tShirtBikeBackText,
          color: textColor,
          id: customizer.tShirtBikeBackText[0].id,
          uOffset: 0.29
        };
        partVariation = {
          ...partVariation,
          ...partsConfig.bikeArt,
          ...textConfig
        };
      }
      if (selectedFrontNumberPlateText) {
        let textData = JSON.parse(
          JSON.stringify(customizer.tShirtBikeFrontNumberPlate)
        ).text;
        if (selectedFrontNumberPlateText.match(/BN\d{2}02F/i)) {
          textData[0].line = `${customizer.tShirtBikeFrontNumberPlate.text[0].line.substring(
            0,
            6
          )}\n${customizer.tShirtBikeFrontNumberPlate.text[0].line.substring(
            6
          )}`;
        }
        const partForData = customizer.availableCustomizations.bikeArt.find(
          x => x.partId === selectedFrontNumberPlateText
        );
        textConfig[selectedFrontNumberPlateText] = {
          text: textData, // customizer.tShirtBikeFrontNumberPlate.text,
          color: '#000',
          uOffset: Number(partForData.configData.uOffset), // Number(customizer.tShirtBikeFrontNumberPlate.uOffset),
          vOffset: Number(partForData.configData.vOffset), // Number(customizer.tShirtBikeFrontNumberPlate.vOffset),
          quality: customizer.tShirtBikeFrontNumberPlate.quality,
          id: customizer.tShirtBikeFrontNumberPlate.text[0].id,
          width: partForData.configData.width // customizer.tShirtBikeFrontNumberPlate.width
        };
        textConfig['NUM001F'] = false;
        partVariation = {
          ...partVariation,
          ...partsConfig.bikeArt,
          ...textConfig
        };
      } else {
        // check if side view is selected,
        // and turn the new number plate on, and turn the same off above

        // easiest way to check this would be checking if no number plate present
        // and one of the front arts is selected /BC\d{4}F/i
        let textData = JSON.parse(
          JSON.stringify(customizer.tShirtBikeFrontNumberPlate)
        ).text;
        textData[0].fontSize = 90;
        const selectedFrontArt = Object.keys(partsConfig.bikeArt).find(
          textId =>
            textId.match(/BC\d{4}F/i) && partsConfig.bikeArt[textId] === true
        );

        if (selectedFrontArt) {
          textConfig['NUM001F'] = {
            text: textData,
            color: textColor,
            uOffset: 0.24,
            vOffset: 0,
            quality: customizer.tShirtBikeFrontNumberPlate.quality,
            id: customizer.tShirtBikeFrontNumberPlate.text[0].id
            // width: customizer.tShirtBikeFrontNumberPlate.width
            // uAng: 0,
            // vAng: 3.14
          };
          partVariation = {
            ...partVariation,
            ...partsConfig.bikeArt,
            ...textConfig
          };
        }
      }
      if (selectedBackNumberPlateText) {
        let textData = JSON.parse(
          JSON.stringify(customizer.tShirtBikeBackNumberPlate)
        ).text;
        if (selectedBackNumberPlateText.match(/BN\d{2}02B/i)) {
          textData[0].line = `${customizer.tShirtBikeBackNumberPlate.text[0].line.substring(
            0,
            6
          )}\n${customizer.tShirtBikeBackNumberPlate.text[0].line.substring(
            6
          )}`;
        }
        const partForData = customizer.availableCustomizations.bikeArt.find(
          x => x.partId === selectedBackNumberPlateText
        );
        textConfig[selectedBackNumberPlateText] = {
          text: textData, // customizer.tShirtBikeBackNumberPlate.text,
          color: '#000',
          uOffset: Number(partForData.configData.uOffset), // Number(customizer.tShirtBikeBackNumberPlate.uOffset),
          vOffset: Number(partForData.configData.vOffset), // Number(customizer.tShirtBikeBackNumberPlate.vOffset),
          quality: customizer.tShirtBikeBackNumberPlate.quality,
          id: customizer.tShirtBikeBackNumberPlate.text[0].id,
          width: partForData.configData.width // customizer.tShirtBikeBackNumberPlate.width
          // uAng: 0,
          // vAng: 3.14
        };
        textConfig['NUM002B'] = false;
        textConfig['NUM001B'] = false;
        partVariation = {
          ...partVariation,
          ...partsConfig.bikeArt,
          ...textConfig
        };
      } else {
        // check if side view is selected,
        // and turn the new number plate on, and turn the same off above

        // easiest way to check this would be checking if no number plate present
        // and one of the back arts is selected /BC\d{4}B/i

        let textData = JSON.parse(
          JSON.stringify(customizer.tShirtBikeBackNumberPlate)
        ).text;
        textData[0].fontSize = 90;
        const selectedBackArt = Object.keys(partsConfig.bikeArt).find(
          textId =>
            textId.match(/BC\d{4}B/i) && partsConfig.bikeArt[textId] === true
        );
        const selectedPlacement = customizer.availableCustomizations.bikeArt.find(
          part =>
            part.customizationType === 'placement' &&
            partsConfig.bikeArt[part.partId] === true
        );

        if (selectedBackArt) {
          const id =
            selectedPlacement && selectedPlacement.name === 'BACK_TEXT_BOTTOM'
              ? 'NUM001B'
              : 'NUM002B';
          textConfig[id] = {
            text: textData,
            color: textColor,
            uOffset: 0.28,
            vOffset: 0,
            // vOffset: Number(customizer.tShirtBikeBackNumberPlate.vOffset),
            quality: customizer.tShirtBikeBackNumberPlate.quality,
            id: customizer.tShirtBikeBackNumberPlate.text[0].id
            // width: customizer.tShirtBikeBackNumberPlate.width
            // uAng: 0,
            // vAng: 3.14
          };
          partVariation = {
            ...partVariation,
            ...partsConfig.bikeArt,
            ...textConfig
          };
        }
      }
      partVariation = { ...partVariation, ...partsConfig[key], ...textConfig };
      // console.log(
      //   { ...partVariation, ...partsConfig[key], ...textConfig },
      //   'debugs'
      // );
    } else if (key === 'backText' && customizer) {
      const selectedText = Object.keys(partsConfig.backText).find(
        textId => partsConfig.backText[textId] === true
      );
      let textData = JSON.parse(JSON.stringify(customizer.tShirtBikeBackText));
      const partForData = customizer.availableCustomizations.backText.find(
        x => x.partId === selectedText
      );
      if (partForData && partForData.configData.fontSize) {
        textData[0].fontSize = 24;
      }
      const textConfig = { ...partsConfig.backText };
      if (selectedText) {
        textConfig[selectedText] = {
          text: textData, //customizer.tShirtBikeBackText,
          color: textColor,
          id: customizer.tShirtBikeBackText[0].id,
          uOffset: 0.29
        };
        partVariation = { ...partVariation, ...textConfig };
      }
    } else {
      partVariation = { ...partVariation, ...partsConfig[key] };
    }
  });

  const flatConfig = { partVariation, versions };
  return flatConfig;
};

export const getNumberOfPartsConfigured = partsConfig => {
  const partsConfigured = Object.keys(partsConfig).filter(
    x => partsConfig[x] === true
  );
  return partsConfigured.length;
};

export const getSummaryInfo = (
  currentCustomizations,
  partsConfig,
  customizer
) => {
  const partVariation = flattenPartsConfiguration(partsConfig, customizer)
    .partVariation;
  const filterredConfig = Object.keys(partVariation).filter(
    x => partVariation[x] === true
  );
  const currentCustomizationsKeys = Object.keys(currentCustomizations);
  const finalData = currentCustomizationsKeys
    .map(custName => {
      const otherInfo = currentCustomizations[custName]
        .map(cust => {
          if (filterredConfig.includes(cust.partId)) {
            return {
              name: cust.name,
              label: cust.configData.label,
              price: cust.price
            };
          }
        })
        .filter(x => x !== undefined);

      return {
        title: custName,
        otherInfo
      };
    })
    .filter(x => x.otherInfo.length !== 0);

  return finalData;
};

export const getTshirtPrice = partsConfig => {
  const isFrontPrintSelected = Object.keys(partsConfig.frontPrint).find(
    x => partsConfig.frontPrint[x] === true
  );
  const isFrontBikeArtSelected = Object.keys(partsConfig.bikeArt).find(
    x => x.match(regexes.frontBikeArtAngle) && partsConfig.bikeArt[x] === true
  );
  const isFrontBadgeSelected = Object.keys(partsConfig.frontBadge).find(
    x => partsConfig.frontBadge[x] === true
  );

  const isBackBikeArtSelected = Object.keys(partsConfig.bikeArt).find(
    x => x.match(regexes.backBikeArtAngle) && partsConfig.bikeArt[x] === true
  );
  const isBackTextSelected = Object.keys(partsConfig.backText).find(
    x => partsConfig.backText[x] === true
  );

  if (
    (isFrontPrintSelected || isFrontBikeArtSelected || isFrontBadgeSelected) &&
    (isBackBikeArtSelected || isBackTextSelected)
  ) {
    return `${1500}`;
  } else {
    return `${1250}`;
  }
};
export const getFinalPriceForSelection = (
  variantData,
  partsConfig,
  customizer
) => {
  const flatConfig = flattenPartsConfiguration(
    partsConfig,
    customizer,
    [],
    '#fff'
  );
  let price = variantData.pricing.basePrice;
  Object.keys(variantData.pricing).forEach(x => {
    if (flatConfig.partVariation[x]) {
      price += variantData.pricing[x];
    }
  });
  return price;
};
export const getHelmetSKU = (variantId, size, visorType = 'normal') => {
  return skuVariantMap[variantId][visorType][size];
};
export const getShirtSKU = (orderJson, partsConfig, size) => {
  let prints = '1';
  const color = orderJson.find(x => x.category === 'baseShirtColor')
    .selectedOption; //"Off White";
  const isFrontPrintSelected = Object.keys(partsConfig.frontPrint).find(
    x => partsConfig.frontPrint[x] === true
  );
  const isFrontBikeArtSelected = Object.keys(partsConfig.bikeArt).find(
    x => x.match(regexes.frontBikeArtAngle) && partsConfig.bikeArt[x] === true
  );
  const isFrontBadgeSelected = Object.keys(partsConfig.frontBadge).find(
    x => partsConfig.frontBadge[x] === true
  );

  const isBackBikeArtSelected = Object.keys(partsConfig.bikeArt).find(
    x => x.match(regexes.backBikeArtAngle) && partsConfig.bikeArt[x] === true
  );
  const isBackTextSelected = Object.keys(partsConfig.backText).find(
    x => partsConfig.backText[x] === true
  );

  if (
    (isFrontPrintSelected || isFrontBikeArtSelected || isFrontBadgeSelected) &&
    (isBackBikeArtSelected || isBackTextSelected)
  ) {
    prints = '2';
  }
  return tshirtSkuVariantMap[prints][color][size];
};

export const getJacketSKU = (variantId, orderJson, partsConfig, size) => {
  const color = orderJson.find(x => x.category === 'jacketColour')
    .selectedOption;
  const winterColor = orderJson.find(x => x.category === 'winterColor')
    .selectedOption;
  const winterProtection = orderJson.find(
    x => x.category === 'winterProtection'
  ).selectedOption;
  const rainProtection = orderJson.find(x => x.category === 'rainProtection')
    .selectedOption;
  const chestArmour = orderJson.find(x => x.category === 'chestArmour')
    .selectedOption;
  const backArmour = orderJson.find(x => x.category === 'backArmour')
    .selectedOption;
  const elbowShouldArmour = orderJson.find(
    x => x.category === 'elbowShouldArmour'
  ).selectedOption;

  const jacketSkuMap = [];

  if (color) {
    jacketSkuMap.push(jacketSkuVariantMap[variantId][color][size]);
  }
  if (winterProtection) {
    const selectedPart = Object.keys(partsConfig.winterProtection).find(
      x => partsConfig.winterProtection[x] === true
    );
    if (selectedPart !== 'WNT000') {
      let color = winterColor || 'Black';
      jacketSkuMap.push(jacketSkuWinterMap[selectedPart][color][size]);
    }
  }
  if (rainProtection) {
    jacketSkuMap.push(jacketSkuRainMap[rainProtection][size]);
  }
  if (chestArmour) {
    const selectedPart = Object.keys(partsConfig.chestArmour).find(
      x => partsConfig.chestArmour[x] === true
    );
    jacketSkuMap.push(jacketSkuArmourMap[selectedPart]);
  }
  if (elbowShouldArmour) {
    const selectedPart = Object.keys(partsConfig.elbowShouldArmour).find(
      x => partsConfig.elbowShouldArmour[x] === true
    );
    jacketSkuMap.push(jacketSkuArmourMap[selectedPart]);
  }
  if (backArmour) {
    const selectedPart = Object.keys(partsConfig.backArmour).find(
      x => partsConfig.backArmour[x] === true
    );
    jacketSkuMap.push(jacketSkuArmourMap[selectedPart][size]);
  }
  return jacketSkuMap;
};

export const generatePartsConfigForDisplay = (customizer, src) => {
  let config = [];
  let orderJson;

  switch (
    customizer.availableVariants[customizer.selectedVariant].accessoryCategory
  ) {
    case 'helmet':
      orderJson = [...JSON.parse(JSON.stringify(orderJsonItemsHelmet))];
      break;
    case 'tshirt':
      orderJson = [...JSON.parse(JSON.stringify(orderJsonItemsTshirt))];
      break;
    case 'jacket':
      orderJson = [...JSON.parse(JSON.stringify(orderJsonItemsJacket))];
      break;
    default:
      orderJson = [...JSON.parse(JSON.stringify(orderJsonItemsHelmet))];
      break;
  }

  Object.keys(customizer.partsConfig).forEach(category => {
    if (
      customizer.availableCategories.map(x => x.name).includes(category) // exclude categories like logo
    ) {
      if (category === 'frontBadge' || category === 'sleeve') {
        const selectedBadges = Object.keys(
          customizer.partsConfig[category]
        ).filter(part => customizer.partsConfig[category][part] === true);
        selectedBadges.forEach(badge => {
          const selectedBadgeCust = customizer.availableCustomizations[
            category
          ].filter(
            x =>
              x.partId.length >= 4 &&
              (x.partId === badge.substring(2) ||
                x.partId.substring(2) === badge.substring(2))
          )[0];
          config = [
            ...config,
            {
              category: `badge_${badge.substring(0, 2)}`,
              icon: customizer.availableCategories.filter(x => {
                return x.name === category;
              })[0].thumbnail,
              selectedOption: selectedBadgeCust.configData.label
            }
          ];
          //  add extra entries if text or tshirt back text only option is selected.
          // bike art text and numberplate will be added inside the specific condition for bikeArt
          const textCategoryReduxMap = {
            text: 'currentText',
            backText: 'tShirtBikeBackText' // tShirtBackText
            // "frontText": "tShirtBikeFrontText",
          };
          if (Object.keys(textCategoryReduxMap).includes(category)) {
            customizer[textCategoryReduxMap[category]].map(
              (textLine, index) => {
                config = [
                  ...config,
                  {
                    category: `${category}Line${index + 1}`,
                    icon: customizer.availableCategories.filter(x => {
                      return x.name === category;
                    })[0].thumbnail,
                    selectedOption: textLine.line
                  }
                ];
              }
            );
          }
        });
      } else if (category === 'bikeArt') {
        const selectedFrontAngleCust = customizer.availableCustomizations.bikeArt.filter(
          x =>
            x.customizationType === 'angle' &&
            x.partId[x.partId.length - 1] === 'F' &&
            customizer.partsConfig.bikeArt[x.partId] === true
        )[0];
        const selectedBackAngleCust = customizer.availableCustomizations.bikeArt.filter(
          x =>
            x.customizationType === 'angle' &&
            x.partId[x.partId.length - 1] === 'B' &&
            customizer.partsConfig.bikeArt[x.partId] === true
        )[0];

        if (selectedFrontAngleCust) {
          const selectedFrontModelCust = customizer.availableCustomizations.bikeArt.filter(
            x => x.partId === selectedFrontAngleCust.configData.linkBack.model
          )[0];
          const selectedFrontColorCust = customizer.availableCustomizations.bikeArt.filter(
            x => x.partId === selectedFrontAngleCust.configData.linkBack.color
          )[0];
          config = [
            ...config,
            {
              category: 'bikeArtFront',
              icon: customizer.availableCategories.filter(x => {
                return x.name === category;
              })[0].thumbnail,
              selectedAngle: selectedFrontAngleCust.configData.label,
              selectedModel: selectedFrontModelCust.configData.label,
              selectedColor: selectedFrontColorCust.configData.label
            },
            ...getBikeTextData(customizer, 'tShirtBikeFrontText'),
            ...getBikeNumberPlateData(customizer, 'tShirtBikeFrontNumberPlate')
          ];
          // adding front bike text key, irrespective of whether they are empty or not. might add that condition later as required
          // console.log(getBikeTextData(customizer,"tShirtBikeFrontText"), getBikeNumberPlateData(customizer, "tShirtBikeFrontNumberPlate"), "bike art text")
        }

        if (selectedBackAngleCust) {
          const selectedBackModelCust = customizer.availableCustomizations.bikeArt.filter(
            x => x.partId === selectedBackAngleCust.configData.linkBack.model
          )[0];
          const selectedBackColorCust = customizer.availableCustomizations.bikeArt.filter(
            x => x.partId === selectedBackAngleCust.configData.linkBack.color
          )[0];
          const selectedPlacementCust = customizer.availableCustomizations.bikeArt.filter(
            x =>
              x.customizationType === 'placement' &&
              customizer.partsConfig.bikeArt[x.partId] === true
          )[0];

          config = [
            ...config,
            {
              category: 'bikeArtBack',
              icon: customizer.availableCategories.filter(x => {
                return x.name === category;
              })[0].thumbnail,
              selectedAngle: selectedBackAngleCust.configData.label,
              selectedModel: selectedBackModelCust.configData.label,
              selectedColor: selectedBackColorCust.configData.label
            },
            ...getBikeTextData(
              customizer,
              'tShirtBikeBackText',
              selectedPlacementCust
            ),
            ...getBikeNumberPlateData(customizer, 'tShirtBikeBackNumberPlate')
          ];
        }
      } else {
        const selectedOption = Object.keys(
          customizer.partsConfig[category]
        ).find(part => customizer.partsConfig[category][part] === true);
        if (selectedOption) {
          const selectdOptionCustomization = customizer.availableCustomizations[
            category
          ].filter(x => x.partId === selectedOption)[0];

          if (category === 'text') {
            customizer.currentText.map((textLine, index) => {
              // config2.forEach(item => {
              //   if (item.category === `${category}Line${index + 1}`) {
              //     item.selectedOption = textLine.line;
              //   }
              // });

              const color = selectdOptionCustomization.configData.hex.includes(
                '000'
              )
                ? 'black'
                : 'white';

              config = [
                ...config,
                {
                  category: `${category}Line${index + 1}`,
                  icon: customizer.availableCategories.filter(x => {
                    return x.name === category;
                  })[0].thumbnail,
                  selectedOption: textLine.line,
                  selectedColor: color
                }
              ];
            });
          } else if (category === 'backText') {
            config = [
              ...config,
              {
                category: `${category}`,
                icon: customizer.availableCategories.filter(x => {
                  return x.name === category;
                })[0].thumbnail,
                selectedOption: customizer.tShirtBikeBackText[0].line,
                selectedType: selectdOptionCustomization.configData.label
              }
            ];
          } else if (category.includes('Armour')) {
            config = [
              ...config,
              {
                category,
                icon: customizer.availableCategories.filter(x => {
                  return x.name === category;
                })[0].thumbnail,
                selectedOption: selectdOptionCustomization.partId
                  ? selectdOptionCustomization.configData.groupKey +
                    ' ' +
                    selectdOptionCustomization.configData.label
                  : '',
                ...(selectdOptionCustomization.configData.orderJsonThumbnail
                  ? {
                      selectedOptionScreenshot:
                        selectdOptionCustomization.configData.orderJsonThumbnail
                    }
                  : {})
              }
            ];
          } else {
            config = [
              ...config,
              {
                category,
                icon: customizer.availableCategories.filter(x => {
                  return x.name === category;
                })[0].thumbnail,
                selectedOption: selectdOptionCustomization.configData.label,
                ...(selectdOptionCustomization.configData.orderJsonThumbnail
                  ? {
                      selectedOptionScreenshot:
                        selectdOptionCustomization.configData.orderJsonThumbnail
                    }
                  : {})
              }
            ];
          }
        }
      }
    }
  });

  const selectedVisorPart = customizer.partsConfig.visor
    ? Object.keys(customizer.partsConfig.visor).find(
        x => customizer.partsConfig.visor[x] === true
      )
    : undefined;

  config.forEach(configItem => {
    orderJson.forEach(item => {
      if (item.category === configItem.category) {
        item.category = item.category.split('/')[0];
        if (
          item.category === 'bikeArtFront' ||
          item.category === 'bikeArtBack'
        ) {
          if (configItem.selectedModel) {
            item.selectedModel = configItem.selectedModel;
            item.selectedModelCode =
              tshirtBikeModelMap[configItem.selectedModel];
          }
          if (configItem.selectedColor) {
            item.selectedColor = configItem.selectedColor;
            item.selectedColorCode =
              tshirtBikeColorMap[configItem.selectedColor];
          }
          if (configItem.selectedAngle) {
            item.selectedAngle = configItem.selectedAngle;
          }
        } else {
          item.selectedOption = configItem.selectedOption;
          item.selectedOptionScreenshot = configItem.selectedOptionScreenshot;
        }
        if (
          configItem.category === 'textLine1' ||
          configItem.category === 'textLine2'
        )
          item.selectedColor = configItem.selectedColor;
        if (
          configItem.category === 'backText' ||
          configItem.category === 'bikeArtBackText'
        )
          item.selectedType = configItem.selectedType;
        if (configItem.category === 'frontPrint')
          item.selectedOptionCode = tshirtPrintMap[item.selectedOption];
        if (
          configItem.category.includes('badge') ||
          configItem.category.includes('sleeve')
        )
          item.selectedOptionCode = tshirtBadgeMap[item.selectedOption];
        if (configItem.category === 'goggle') item.selectedOption = 'Yes';
        if (
          customizer.selectedVariant === 'HelmetFullFace' &&
          configItem.category === 'visor'
        )
          item.selectedOption = 'FullFace';
      } else if (item.category.split('/').includes(configItem.category)) {
        item.category = configItem.category;
        item.selectedOption = configItem.selectedOption;
      } else {
        if (customizer.selectedVariant === 'HelmetUrbanTrooper')
          item.category = item.category.split('/')[0];
      }
    });
  });
  const accessoryType =
    customizer.availableVariants[customizer.selectedVariant].accessoryCategory;
  const displayConfig = {
    thumbnail: src,
    size: customizer.selectedSize,
    totalPrice:
      customizer.selectedVariant === 'TShirt'
        ? getTshirtPrice(customizer.partsConfig)
        : getFinalPriceForSelection(
            customizer.availableVariants[customizer.selectedVariant],
            customizer.partsConfig,
            customizer
          ),
    partsConfig: orderJson,
    sku: getSKU(
      accessoryType,
      orderJson,
      customizer.partsConfig,
      customizer.selectedSize,
      customizer.selectedVariant,
      selectedVisorPart
    ),
    productType: accessoryType
  };
  return displayConfig;
};

const getSKU = (
  accessoryType,
  orderJson,
  partsConfig,
  size,
  variant,
  visorPart
) => {
  switch (accessoryType) {
    case 'helmet':
      return getHelmetSKU(variant, size, visorPart);
    case 'tshirt':
      return getShirtSKU(orderJson, partsConfig, size);
    case 'jacket':
      return getJacketSKU(variant, orderJson, partsConfig, size);
  }
};
const getBikeTextData = (customizer, textKey, selectedPlacementCust) => {
  const textLabelMap = {
    tShirtBikeFrontText: 'bikeArtFrontText',
    tShirtBikeBackText: 'bikeArtBackText'
  };

  let additionalConfig = [];
  additionalConfig = [
    ...additionalConfig,
    ...[
      ...customizer[textKey].map(textLine => {
        return {
          category: `${textLabelMap[textKey]}`,
          icon: customizer.availableCategories.filter(x => {
            return x.name === 'bikeArt';
          })[0].thumbnail,
          selectedOption: textLine.line,
          selectedType:
            selectedPlacementCust && textLine.line !== ''
              ? selectedPlacementCust.configData.label
              : ''
        };
      })
    ]
  ];
  return additionalConfig;
};
const getBikeNumberPlateData = (customizer, textKey) => {
  const textLabelMap = {
    tShirtBikeFrontNumberPlate: 'bikeArtFrontNumberPlate',
    tShirtBikeBackNumberPlate: 'bikeArtBackNumberPlate'
  };
  let additionalConfig = [];
  additionalConfig = [
    ...additionalConfig,
    {
      category: `${textLabelMap[textKey]}`,
      icon: customizer.availableCategories.filter(x => {
        return x.name === 'bikeArt';
      })[0].thumbnail,
      selectedOption: customizer[textKey].text[0].line
    }
  ];
  return additionalConfig;
};
const uploadAndSaveThumbnail = async (customizer, blob, userConfigId) => {
  const {
    data: { signedUrl, fileName, srcUrl }
  } = await axios.post('configurations/thumbnail/url', {
    userId: customizer.userId || customizer.sessionId || 'scapic',
    configId: userConfigId,
    file: { extension: 'png' }
  });
  const file = new File([blob], `${fileName}.png`, { type: 'image/png' });
  const axiosInstance = axios.create({});
  await axiosInstance.put(signedUrl, file, {
    headers: {
      'x-ms-blob-type': 'BlockBlob',
      'Content-Type': 'image/png'
    }
  });
  return { srcUrl };
};
const viewSuffix = {
  lhs: 'back',
  sleeveLeft: 'left',
  sleeveRight: 'right'
};
const getExtraThumbnails = async (customizer, userConfigId, views) => {
  const response = {};
  for (let view of views) {
    let res = await window.ScapicSDK.screenshot({ view });
    let blob = dataURItoBlob(res.screenshot);
    const {
      data: { signedUrl, fileName, srcUrl }
    } = await axios.post('configurations/thumbnail/url', {
      userId: customizer.userId || customizer.sessionId || 'scapic',
      configId: userConfigId,
      file: { extension: 'png' },
      view: viewSuffix[view]
    });
    const file = new File([blob], `${fileName}.png`, { type: 'image/png' });
    const axiosInstance = axios.create({});
    await axiosInstance.put(signedUrl, file, {
      headers: {
        'x-ms-blob-type': 'BlockBlob',
        'Content-Type': 'image/png'
      }
    });
    response[`thumbnail_${viewSuffix[view]}`] = srcUrl;
    // let url = window.URL.createObjectURL(blob);
    // let a = document.createElement("a");
    // document.body.appendChild(a);
    // a.style = "display: none";
    //     a.href = url;
    //     a.download = `${userConfigId}_${view}`;
    //     a.click();
    //     window.URL.revokeObjectURL(url);
  }
  return response;
};

export const savePartsConfiguration = (
  customizer,
  isAddingToCart = false
) => async dispatch => {
  dispatch(setIsLoading(true));
  // window.ScapicSDK.save(customizer.partsConfig);
  let extraImagesData = {};
  const screenshotView =
    customizer.selectedVariant === 'TShirt' ||
    !customizer.selectedVariant.includes('Helmet')
      ? 'rhs'
      : 'helmet';
  const res = await window.ScapicSDK.screenshot({ view: screenshotView });
  const blob = dataURItoBlob(res.screenshot);
  const textSelected = customizer.availableCustomizations.text
    ? customizer.availableCustomizations.text.find(
        entry =>
          entry.partId ===
          Object.keys(customizer.partsConfig.text).filter(
            key => customizer.partsConfig.text[key] === true
          )[0]
      )
    : null;
  let textColor = null;
  if (textSelected) {
    textColor = textSelected.configData.hex;
  }
  const flatConfig = flattenPartsConfiguration(
    customizer.partsConfig,
    customizer,
    customizer.currentText,
    textColor
  );
  const displayConfig = generatePartsConfigForDisplay(customizer, 'srcUrl');
  // make api call to save both flat config and display config
  if (!customizer.userConfigId) {
    const userConfig = await saveUserConfig(
      customizer.userId || customizer.sessionId || 'scapic',
      customizer.selectedVariant,
      flatConfig,
      displayConfig
    );
    dispatch(setUserConfigId(userConfig._id));
    const { srcUrl } = await uploadAndSaveThumbnail(
      customizer,
      blob,
      userConfig._id
    );
    if (
      customizer.selectedVariant === 'TShirt' ||
      !customizer.selectedVariant.includes('Helmet')
    ) {
      extraImagesData = await getExtraThumbnails(customizer, userConfig._id, [
        'lhs',
        'sleeveRight',
        'sleeveLeft'
      ]);
    }
    await editUserConfig(
      userConfig._id,
      customizer.userId || customizer.sessionId || 'scapic',
      customizer.selectedVariant,
      flatConfig,
      { ...displayConfig, thumbnail: srcUrl, ...extraImagesData }
    );
    if (isAddingToCart) {
      if (customizer.userId !== null) {
        dispatch(setUserConfigId(null));

        // user is logged in
        let appType = 'helmet';
        if (customizer.selectedVariant === 'TShirt') {
          appType = 'tshirt';
        } else if (customizer.selectedVariant.includes('Helmet')) {
          appType = 'helmet';
        } else {
          appType = 'jacket';
        }
        window.parent.postMessage(
          {
            module: appType,
            event: 'addtocart',
            configId: btoa(userConfig._id)
          },
          customizer.siteUrl !== null ? customizer.siteUrl : '*'
        );
        // AnalyticsStub.onAddToCart(
        //   customizer.userId,
        //   userConfig._id,
        //   customizer.selectedVariant
        // );
      }
    }
    if (customizer.userId) {
      dispatch(
        getSavedConfigsForUser(customizer.userId, displayConfig.productType)
      );
    } else {
      // send userConfig._id back to window using api or postMessage
      // window.parent.postMessage(
      //   {
      //     module: customizer.selectedVariant === 'TShirt' ? 'tshirt' : 'helmet',
      //     event: 'login',
      //     configId: btoa(userConfig._id)
      //   },
      //   customizer.siteUrl !== null ? customizer.siteUrl : '*'
      // );
    }
    dispatch(setIsLoading(false));
    dispatch(setSnackbar({ isOpen: true, text: 'Saved Successfully !' }));
  } else {
    const { srcUrl } = await uploadAndSaveThumbnail(
      customizer,
      blob,
      customizer.userConfigId
    );
    if (
      customizer.selectedVariant === 'TShirt' ||
      !customizer.selectedVariant.includes('Helmet')
    ) {
      // save extra thsirt views
      extraImagesData = await getExtraThumbnails(
        customizer,
        customizer.userConfigId,
        ['lhs', 'sleeveRight', 'sleeveLeft']
      );
    }
    await editUserConfig(
      customizer.userConfigId,
      customizer.userId || customizer.sessionId || 'scapic',
      customizer.selectedVariant,
      flatConfig,
      { ...displayConfig, thumbnail: srcUrl, ...extraImagesData }
    );
    if (isAddingToCart) {
      if (customizer.userId !== null) {
        // user is logged in
        window.parent.postMessage(
          {
            module:
              customizer.selectedVariant === 'TShirt'
                ? 'tshirt'
                : customizer.selectedVariant.includes('Helmet')
                ? 'helmet'
                : 'jacket',
            event: 'addtocart',
            configId: btoa(customizer.userConfigId)
          },
          customizer.siteUrl !== null ? customizer.siteUrl : '*'
        );
        // AnalyticsStub.onAddToCart(
        //   customizer.userId,
        //   customizer.userConfigId,
        //   customizer.selectedVariant
        // );
      }
      dispatch(setUserConfigId(null));
    }
    dispatch(getSavedConfigsForUser(customizer.userId));
    dispatch(setIsLoading(false));
    dispatch(setSnackbar({ isOpen: true, text: 'Updated Successfully !' }));
  }
  // then(res => {

  // const src = URL.createObjectURL(blob);
  // axios
  //   .post('configurations/thumbnail/url', {
  //     userId: customizer.userId || customizer.sessionId || 'scapic',
  //     file: { extension: 'png' }
  //   })
  //   .then(reponse => {
  //     const { signedUrl, fileName, srcUrl } = reponse.data; // decodeURIComponent(reponse.data.signedUrl);
  //     const file = new File([blob], `${fileName}.png`, { type: 'image/png' });
  //     const axiosInstance = axios.create({});
  //     axiosInstance
  //       .put(signedUrl, file, {
  //         headers: {
  //           'x-ms-blob-type': 'BlockBlob',
  //           'Content-Type': 'image/png'
  //         }
  //       })
  //       .then(() => {
  //         const textSelected = customizer.availableCustomizations.text.find(
  //           entry =>
  //             entry.partId ===
  //             Object.keys(customizer.partsConfig.text).filter(
  //               key => customizer.partsConfig.text[key] === true
  //             )[0]
  //         );
  //         let textColor = null;
  //         if (textSelected) {
  //           textColor = textSelected.configData.hex;
  //         }
  //         const flatConfig = flattenPartsConfiguration(
  //           customizer.partsConfig,
  //           customizer.currentText,
  //           textColor
  //         );
  //         const displayConfig = generatePartsConfigForDisplay(
  //           customizer,
  //           srcUrl
  //         );
  //         // make api call to save both flat config and display config
  //         if (!customizer.userConfigId) {
  //           saveUserConfig(
  //             customizer.userId || customizer.sessionId || 'scapic',
  //             customizer.selectedVariant,
  //             flatConfig,
  //             displayConfig
  //           ).then(userConfig => {
  //             // update user config id on redux
  //             dispatch(setUserConfigId(userConfig._id));
  //             if (isAddingToCart) {
  //               if (customizer.userId !== null) {
  //                 window.parent.postMessage(
  //                   {
  //                     module: 'helmet',
  //                     event: 'addtocart',
  //                     configId: btoa(userConfig._id)
  //                   },
  //                   customizer.siteUrl !== null ? customizer.siteUrl : '*'
  //                 );
  //               }
  //               dispatch(setUserConfigId(null));
  //             }
  //             if (customizer.userId) {
  //               dispatch(getSavedConfigsForUser(customizer.userId));
  //             } else {
  //               // send userConfig._id back to window using api or postMessage
  //               window.parent.postMessage(
  //                 { module: 'helmet', event: 'login' },
  //                 customizer.siteUrl !== null ? customizer.siteUrl : '*'
  //               );
  //             }
  //             dispatch(setIsLoading(false));
  //             dispatch(
  //               setSnackbar({ isOpen: true, text: 'Saved Successfully !' })
  //             );
  //           });
  //         } else {
  //           editUserConfig(
  //             customizer.userConfigId,
  //             customizer.userId,
  //             customizer.selectedVariant,
  //             flatConfig,
  //             displayConfig
  //           ).then(reponse => {
  //             dispatch(getSavedConfigsForUser(customizer.userId));
  //             dispatch(setIsLoading(false));
  //             dispatch(
  //               setSnackbar({ isOpen: true, text: 'Updated Successfully !' })
  //             );
  //           });
  //         }
  //       })
  //       .catch(e => console.error(e, 'error'));
  //   });
  // });
};

export const saveUserConfig = async (
  userId,
  variantId,
  flatConfig,
  displayConfig
) => {
  try {
    const response = await axios.post('/userConfig', {
      userId,
      variantId,
      loadConfig: flatConfig,
      orderJson: displayConfig
    });

    // AnalyticsStub.configSaved(userId, response.data.confidId, variantId);
    return response.data;
  } catch (err) {
    console.error(err);
  }
};

export const editUserConfig = async (
  userConfigId,
  userId,
  variantId,
  flatConfig,
  displayConfig
) => {
  try {
    const response = await axios.put(`/userConfig/${userConfigId}`, {
      userId,
      variantId,
      loadConfig: flatConfig,
      orderJson: displayConfig
    });
    return response.data;
  } catch (err) {
    console.error(err);
  }
};

export const getUserConfig = async userConfigId => {
  try {
    const response = await axios.get(`/userConfig/${userConfigId}`);
    return response.data;
  } catch (err) {
    console.error(err);
  }
};

export const getSavedConfigsForUser = (userId, type) => async dispatch => {
  try {
    const response = await axios.get(
      `/userConfig/user/${userId || 'scapic'}/${type}`
    );
    // return response.data;
    dispatch(populateSavedUserConfigs(response.data));
  } catch (err) {
    console.error(err);
  }
};
export const removeUserConfig = (userId, userConfigId) => async (
  dispatch,
  getState
) => {
  const { customizer } = getState();
  try {
    const response = await axios.delete(`/userConfig/${userConfigId}`);
    // return response.data;
    // dispatch(
    //   getSavedConfigsForUser(
    //     userId,
    //     customizer.selectedVariant === 'TShirt' ? 'tshirt' : 'helmet'
    //   )
    // );
    if (userConfigId === customizer.userConfigId) {
      dispatch(setUserConfigId(null));
      dispatch(setIsConfigSaved(false));
    }
    dispatch(setIsLoading(false));
  } catch (err) {
    console.error(err);
  }
};

export const assignSessionDataToUser = (userId, configId) => async (
  dispatch,
  getState
) => {
  const { customizer } = getState();
  try {
    const response = await axios.put(`/userConfig/assign`, {
      userId,
      configId
    });
    // return response.data;
    const userConfigId = response.data._id;
    // dispatch(
    //   getSavedConfigsForUser(
    //     userId,
    //     customizer.selectedVariant === 'TShirt' ? 'tshirt' : 'helmet'
    //   )
    // );
    if (userConfigId === customizer.userConfigId) {
      const res = await window.ScapicSDK.screenshot({ view: 'rhs' });
      const blob = dataURItoBlob(res.screenshot);
      const { srcUrl } = await uploadAndSaveThumbnail(
        customizer,
        blob,
        userConfigId
      );
      const configToEdit = await getUserConfig(userConfigId);
      await editUserConfig(
        userConfigId,
        userId,
        configToEdit.configuration.variantId,
        {
          partVariation: {
            ...configToEdit.configuration.partVariation,
            ...configToEdit.textData
          },
          versions: { ...configToEdit.configuration.versions }
        },
        { ...response.data.orderJson, thumbnail: srcUrl }
      );
      dispatch(editUserConfig);
      dispatch(setUserConfigId(userConfigId));
      dispatch(setIsConfigSaved(false));
    }
    dispatch(setIsLoading(false));
  } catch (err) {
    console.error(err);
  }
};

export const savePdfToUserConfig = async (userConfigId, userId, pdfUrl) => {
  try {
    const response = await axios.put(`/userConfig/savePdf/${userConfigId}`, {
      pdfUrl
    });
    return response.data;
  } catch (err) {
    console.error(err);
  }
};
export const markOrderPlaced = async (userConfigId, userId) => {
  try {
    const response = await axios.put(`/userConfig/orderPlaced/${userConfigId}`);
    return response.data;
  } catch (err) {
    console.error(err);
  }
};
export const loadFromSavedUserConfig = userConfig => async dispatch => {
  dispatch(setUserConfigId(null));
  dispatch(setIsLoading(true));
  // dispatch(setSelectedVariant(userConfig.variantId));
  // dispatch(setIsDataReady(true));
  const textPartData = {};
  let textToBeSet = ['', ''];
  const textReduxMap = {
    frontText: setFrontBikeText,
    backText: setBackBikeText,
    frontNumberPlate: setFrontBikeNumberPlate,
    backNumberPlate: setBackBikeNumberPlate
    // "text": setCurrentText
  };
  const textUpdateData = {};
  if (userConfig.textData) {
    Object.keys(userConfig.textData).forEach(id => {
      if (!userConfig.textData[id]) {
        textPartData[id] = false;
      } else {
        textPartData[id] = true;
        textToBeSet = userConfig.textData[id].text;
        textUpdateData[userConfig.textData[id].id] =
          userConfig.textData[id].text;
      }
    });
  }

  const selectedFrontNP = Object.keys(
    userConfig.configuration.partVariation
  ).find(
    id =>
      id.match(regexes.frontNumberPlate) &&
      userConfig.configuration.partVariation[id]
  );
  if (selectedFrontNP) {
    const selectedFrontNPData =
      userConfig.configuration.partVariation[selectedFrontNP];
    dispatch(
      textReduxMap['frontNumberPlate'](
        selectedFrontNPData.text[0].line,
        selectedFrontNPData.uOffset,
        selectedFrontNPData.vOffset,
        selectedFrontNPData.text[0].fontSize
      )
    );
  }

  const selectedBackNP = Object.keys(
    userConfig.configuration.partVariation
  ).find(
    id =>
      id.match(regexes.backNumberPlate) &&
      userConfig.configuration.partVariation[id]
  );
  if (selectedBackNP) {
    const selectedBackNPData =
      userConfig.configuration.partVariation[selectedBackNP];
    dispatch(
      textReduxMap['backNumberPlate'](
        selectedBackNPData.text[0].line,
        selectedBackNPData.uOffset,
        selectedBackNPData.vOffset,
        selectedBackNPData.text[0].fontSize
      )
    );
  }

  Object.keys(textUpdateData).forEach(id => {
    if (textReduxMap[id])
      dispatch(textReduxMap[id](textUpdateData[id][0].line));
  });
  dispatch(setCurrentText(textToBeSet, 'none'));
  dispatch(
    getCurrentPartsConfigFromFlatConfig({
      ...userConfig.configuration,
      partVariation: {
        ...userConfig.configuration.partVariation,
        ...textPartData,
        ...userConfig.configuration.versions
      }
    })
  );
};
/**
 * @summary get back the whole partsConfig object in its usual form, from the saved config
 * will be called when user tries to configure a saved configuration from link.
 * @param {*} availableVariants available variants data from flat
 * @param {*} savedConfig saved part variation config flat object
 */
export const getCurrentPartsConfigFromFlatConfig = savedConfig => async dispatch => {
  const partsConfig = {};
  const { data: accessoryData } = await axios.get(
    `accessoryTypes/variant/${savedConfig.variantId}`
  );
  const { data: availableCustomizations } = await axios.get(
    `customizations/variants/${savedConfig.variantId}`
  );
  let isLoadingCategories = false;
  dispatch(setIsLoading(true));
  dispatch(setSelectedVariant(savedConfig.variantId));

  Object.keys(availableCustomizations)
    .filter(cust => availableCustomizations[cust].length > 0)
    .forEach((categoryName, i) => {
      const lastIndex =
        Object.keys(availableCustomizations).filter(
          cust => availableCustomizations[cust].length > 0
        ).length - 1;
      if (availableCustomizations[categoryName].length > 0) {
        const customizations = availableCustomizations[categoryName].map(
          part => part.partId
        );
        const isCategoryLoaded = window.ScapicSDK
          ? window.ScapicSDK.ensurePartIdsLoaded(customizations)
          : true;
        const selectedPart = Object.keys(savedConfig.partVariation).find(
          part =>
            customizations.includes(part) &&
            savedConfig.partVariation[part] === true
        );
        if (!isCategoryLoaded && selectedPart) {
          // dispatch(setIsLoading(true))
          isLoadingCategories = true;
          window.ScapicSDK.loadPartIds(customizations).then(() => {
            dispatch(setIsLoading(false));
          });
        }
        if (i === lastIndex && !isLoadingCategories)
          dispatch(setIsLoading(false));
        // else dispatch(setIsLoading(false));
        partsConfig[categoryName] = {};
        let parts = availableCustomizations[categoryName].map(
          item => item.partId
        );
        if (categoryName === 'frontBadge' || categoryName === 'sleeve') {
          const config = [];

          // parts should have updated part ids appendedd with position
          availableCustomizations[categoryName].forEach(item => {
            availableHotspots
              .filter(
                part =>
                  (categoryName === 'frontBadge' && !part.includes('S')) ||
                  (categoryName === 'sleeve' && part.includes('S'))
              )
              .forEach(hotspot => {
                const partId =
                  item.partId.length === 4
                    ? hotspot.substring(1, 3) + item.partId
                    : item.partId.replace(
                        item.partId.substring(0, 2),
                        hotspot.substring(1, 3)
                      );
                config.push(partId);
              });
          });
          parts = config;
        }
        const partData = {};
        parts.forEach(partId => {
          partData[partId] = savedConfig.partVariation[partId];
        });
        if (categoryName === 'text') {
          // when no text present, a color is still selected so partId should be true on front but not for sdk to avoid loading mesh
          if (!Object.keys(partData).find(x => partData[x] === true)) {
            const selectedBaseColorId = Object.keys(partsConfig.baseColor).find(
              x => partsConfig.baseColor[x] === true
            );
            const selectedBaseColor = availableCustomizations.baseColor.find(
              x => x.partId === selectedBaseColorId
            );
            const selectedDecalId = Object.keys(partsConfig.decal).find(
              x => partsConfig.decal[x] === true
            );
            const secondaryDependencies =
              selectedBaseColor.secondaryDependencies[selectedDecalId];
            const textAvailable = secondaryDependencies.filter(x =>
              x.match(regexes.text)
            );
            if (textAvailable.length !== 0) partData[textAvailable[0]] = true;
          }
        }
        partsConfig[categoryName] = partData;
      }
    });
  const availableCategories = accessoryData.customizationCategories.filter(
    category => {
      return (
        (category.childCategories && category.childCategories.length > 0) ||
        category.categoryType === 'subCategory' ||
        category.name === 'sleeve' ||
        Object.keys(partsConfig[category.name]).find(
          part => partsConfig[category.name][part] === true
        ) ||
        (partsConfig.visor &&
          Object.keys(partsConfig.visor).find(
            part => partsConfig.visor[part] === true
          ) === 'VSRT02' &&
          category.name === 'goggle') ||
        (category.name === 'goggle' && !partsConfig.visor) // extra condition for UT where goggle is not dependent on visor
      );
    }
  );

  // batch(() => {
  dispatch(setAvailableVariants(accessoryData.variantId, accessoryData));
  dispatch(setAvailableCategories(availableCategories));
  dispatch(setAvailableCustomizations(availableCustomizations));
  dispatch(populateAllPartsConfig(partsConfig));
  dispatch(setSelectedCategory(Object.keys(availableCustomizations)[0]));
  dispatch(setCurrentActiveParent(null));
  // dispatch(setSelectedVariant(savedConfig.variantId));
  dispatch(setIsConfigSaved(true));
  dispatch(pushToUndoStack());
  dispatch(pushToRedoStack());
  // dispatch(setIsLoading(false));
  dispatch(setIsDataReady(true));
  // });
  return partsConfig;
};

export const loadConfig = (
  userId,
  userConfigId,
  sessionId
) => async dispatch => {
  try {
    const userConfig = await getUserConfig(userConfigId);
    // if (userConfig.userId === userId) {
    dispatch(setUserId(userId));
    dispatch(loadFromSavedUserConfig(userConfig));
    dispatch(assignSessionDataToUser(userId, userConfigId));
    // } else {
    //   console.error("config doesn't belong to this user");
    // }
  } catch (err) {
    console.error(err);
  }
};
/**
 * @summary called immediately on tab click, and on coming to configurator the first time, having selected accessory from outside.
 * will populate the "availableVariants" field with required data.
 * won't be dependent on the specific model selected.
 * param: accessoryCategory : "helmet", "tshirt" or "jacket"
 * @param {*} dispatch
 */
export const getAllAccessoryTypeDataOnTabClick = accessoryCategory => async dispatch => {
  try {
    const accessoryData = await axios.get(
      `accessoryTypes/category/${accessoryCategory}`
    );

    // should set "availableVariants" above
    dispatch(setVariantData(accessoryData.data));

    dispatch(setSelectedCategory('baseShirtColor'));
  } catch (err) {
    console.error(err);
  }
};

export const updatePartsConfig = (
  data,
  category,
  ignoredList,
  isInitialLoad
) => dispatch => {
  dispatch(
    updatePartsConfigForCategory(data, category, ignoredList, isInitialLoad)
  );
  dispatch(setIsConfigSaved(false));
};

const getLogoAndIsiData = (state, secondaryDependencies) => {
  const responseData = {};
  // logo data
  const logos = secondaryDependencies.filter(x => x.match(/LDC\d{3}/));
  const allLogos = state.availableCustomizations.logo.map(item => item.partId);
  const logoConfigData = {};
  allLogos.forEach(x => {
    if (logos && logos.includes(x)) logoConfigData[x] = true;
    else logoConfigData[x] = false;
  });
  responseData.logo = logoConfigData;
  // isi mark data
  const isiMarks = secondaryDependencies.filter(x => x.match(/ISI\d{3}/));
  const allIsiMarks = state.availableCustomizations.isi.map(
    item => item.partId
  );
  const isiMarkConfigData = {};
  allIsiMarks.forEach(x => {
    if (isiMarks.includes(x)) isiMarkConfigData[x] = true;
    else isiMarkConfigData[x] = false;
  });
  responseData.isi = isiMarkConfigData;
  return responseData;
};

const getLogoDataForDecal = (state, decalData) => {
  const currentBaseColorPartId = Object.keys(state.partsConfig.baseColor).find(
    key => {
      return state.partsConfig.baseColor[key] === true;
    }
  );
  const baseColor = state.availableCustomizations.baseColor.find(
    x => x.partId === currentBaseColorPartId
  );
  const decalPartId = decalData.partId;
  const secondaryDependencies = baseColor.secondaryDependencies[decalPartId];
  const responseData = getLogoAndIsiData(state, secondaryDependencies);
  return responseData;
};

const resolveSecondaryDepsForBodyColor = (state, selectedOption) => {
  let responseData = {};
  const baseColor = selectedOption;
  const currentDecalPartId = state.partsConfig.decal
    ? Object.keys(state.partsConfig.decal).find(key => {
        return state.partsConfig.decal[key] === true;
      })
    : null;
  if (currentDecalPartId) {
    let secondaryDependencies =
      baseColor.secondaryDependencies[currentDecalPartId];
    if (!secondaryDependencies) {
      const decalToBeApplied = Object.keys(baseColor.secondaryDependencies)[0];
      secondaryDependencies = baseColor.secondaryDependencies[decalToBeApplied];
    }
    responseData = getLogoAndIsiData(state, secondaryDependencies);
    return responseData;
  }
};

const categoriesWithSecondaryDep = ['text', 'logo', 'isi', ''];
const extraDecalPartIds = {
  HelmetOpenFace: 'DCL010',
  HelmetFullFace: 'DCL011'
};

const regexes = {
  baseColor: /BCL\d{3}/i,
  decal: /DCL\d{3}/i,
  finish: /FSH\d{3}/i,
  goggle: /GLS\d{3}/i,
  visor: /VSRT\d{2}/i,
  visorColor: /VSR\d{3}/i,
  peakColor: /PEK\d{3}/i,
  logo: /LDC\d{3}/i,
  text: /TXT\d{3}/i,
  internalFabricColor: /INF\d{3}/i,
  baseRegex: /BCL\d{3}/i,
  secondaryRegex: /DCL\d{3}/i,
  frontNumberPlate: /BN\d{4}F/i,
  backNumberPlate: /BN\d{4}B/i,
  frontBikeArtAngle: /BC\d{4}F/i,
  backBikeArtAngle: /BC\d{4}B/i
};

const checkForAvailablePart = (
  availableCustomizations,
  catName,
  depSelectedPartId,
  colSelectedPartId,
  depRegex,
  colRegex
) => {
  const availablePart = availableCustomizations[catName].find(entry => {
    if (
      entry.dependencies.parts.some(part => part.match(depRegex)) ||
      entry.collisions.parts.some(part => part.match(colRegex))
    ) {
      if (
        (depSelectedPartId &&
          entry.dependencies.parts.includes(depSelectedPartId)) ||
        (colSelectedPartId &&
          entry.collisions.parts.includes(colSelectedPartId)) ||
        (depSelectedPartId &&
          entry.dependencies.parts.includes(depSelectedPartId) &&
          colSelectedPartId &&
          entry.collisions.parts.includes(colSelectedPartId))
      ) {
        return true;
      }
      return false;
    }
    return true;
  });

  return availablePart;
};

const compareAndCreateNewCategories = (
  availableCategories,
  categoriesAfterDeps,
  categoriesAfterSecDeps
) => {
  let newAvailableCategories = [...availableCategories];
  const concatedCategories = categoriesAfterDeps.concat(categoriesAfterSecDeps);
  const symmDiff = categoriesAfterDeps
    .filter(x => !categoriesAfterSecDeps.includes(x))
    .concat(
      categoriesAfterSecDeps.filter(x => !categoriesAfterDeps.includes(x))
    );

  concatedCategories.forEach(cat => {
    if (
      categoriesAfterDeps.length !== 0 &&
      categoriesAfterSecDeps.length !== 0
    ) {
      if (symmDiff.includes(cat) && newAvailableCategories.includes(cat)) {
        const indexOfRemovedCategory = newAvailableCategories.indexOf(cat);
        newAvailableCategories.splice(indexOfRemovedCategory, 1);
      } else if (
        symmDiff.includes(cat) &&
        newAvailableCategories.includes(cat)
      ) {
        newAvailableCategories.push(cat);
      }
    } else if (categoriesAfterDeps.length === 0) {
      newAvailableCategories = [...categoriesAfterSecDeps];
    } else if (categoriesAfterSecDeps.length === 0) {
      newAvailableCategories = [...categoriesAfterDeps];
    }
  });
  return newAvailableCategories;
};

const updateCategories = (
  allCategories,
  selectedPart,
  availableCategories,
  availableCustomizations,
  shoulReapplyCustomization,
  currentActiveParent,
  selectedCategory,
  partsConfig
) => {
  const updatedCategories = checkForCategoryCollisionAndDep(
    selectedPart,
    availableCategories,
    availableCustomizations,
    shoulReapplyCustomization,
    allCategories,
    currentActiveParent,
    selectedCategory,
    partsConfig
  );

  const newAvailableCategories = availableCategories.filter(
    cat => !updatedCategories.removed.includes(cat.name)
  );

  allCategories.forEach(cat => {
    if (updatedCategories.added.includes(cat.name)) {
      newAvailableCategories.push(cat);
    }
  });
  // sorting available categories
  const catOrder = Object.keys(availableCustomizations);
  const sortedCats = newAvailableCategories.sort((a, b) => {
    if (catOrder.indexOf(a.name) < catOrder.indexOf(b.name)) {
      return -1;
    }
    if (catOrder.indexOf(a.name) > catOrder.indexOf(b.name)) {
      return 1;
    }
    return 0;
  });
  return {
    changedConfig: updatedCategories.changedConfig,
    newAvailableCategories: sortedCats,
    shouldContinue: updatedCategories.shouldContinue,
    oldCategory: updatedCategories.oldCategory
  };
};

const findAndSelectAvailablePart = (
  availableCustomizations,
  catName,
  allCategories,
  selectedOptionInCategory,
  partsConfig,
  availablePart,
  availableCategories,
  shoulReapplyCustomization,
  selectedVariant,
  secondAvailablePart = null,
  currentActiveParent,
  selectedCategory
) => {
  let newPartsConfig = partsConfig;

  const allPartsForSelectedCategory = getAllPartsForCategory(
    availableCustomizations,
    catName
  );

  const categoryConfig = {};
  allPartsForSelectedCategory.forEach(item => {
    categoryConfig[item] = false;
  });
  categoryConfig[availablePart.partId] = true;
  newPartsConfig[catName] = categoryConfig;

  const {
    changedConfig,
    newAvailableCategories,
    shouldContinue,
    oldCategory
  } = updateCategories(
    allCategories,
    availablePart,
    availableCategories,
    availableCustomizations,
    shoulReapplyCustomization,
    currentActiveParent,
    selectedCategory,
    partsConfig
  );
  newPartsConfig = { ...newPartsConfig, ...changedConfig };

  const recalculatedConfig = checkForPartsCollisionAndDep(
    availableCustomizations[catName].find(
      part => part.partId === availablePart.partId
    ),
    catName,
    newPartsConfig,
    allCategories,
    availableCustomizations,
    newAvailableCategories,
    shoulReapplyCustomization,
    selectedVariant,
    currentActiveParent,
    partsConfig
  );

  let config = {};

  if (recalculatedConfig.shouldContinue) {
    if (secondAvailablePart) {
      config = {
        ...recalculatedConfig.config,
        ...changedConfig,
        [catName]: {
          ...partsConfig[catName],
          [selectedOptionInCategory]: false,
          [availablePart.partId]: true,
          [secondAvailablePart.partId]: true
        }
      };
    } else {
      config = {
        ...recalculatedConfig.config,
        ...changedConfig,
        [catName]: {
          ...partsConfig[catName],
          [selectedOptionInCategory]: false,
          [availablePart.partId]: true
        }
      };
    }
  }
  return { config, newAvailableCategories, shouldContinue, oldCategory };
};

const getOrder = item => {
  const name = item.name.split('_');
  const viewCode = item.partId.substring(item.partId.length - 1);
  let index = viewCode === 'F' ? name.length - 1 : name.length - 2;
  const angle = name[index];

  switch (angle) {
    case 'FRONTVIEW':
      return 0;
    case 'SIDEVIEW':
      return 1;
    case 'BACKVIEW':
      return 2;
    default:
      return 0;
  }
};

const compare = (a, b) => {
  if (getOrder(a) < getOrder(b)) {
    return -1;
  } else if (getOrder(a) > getOrder(b)) {
    return 1;
  } else {
    return 0;
  }
};

const checkForPartsCollisionAndDep = (
  selectedPart,
  selectedCategory,
  partsConfig,
  allCategories,
  availableCustomizations,
  availableCategories,
  shoulReapplyCustomization,
  selectedVariant,
  currentActiveParent
) => {
  const newConfig = {
    shouldContinue: true,
    oldCategory: null,
    config: {},
    availableCategories,
    alertInfo: {}
  };

  // const oldCategory = null;

  let categoriesAfterSecDeps = [];
  let categoriesAfterDeps = [];

  const allSubCategories = allCategories
    .filter(cat => cat.categoryType === 'subCategory')
    .map(cat => cat.name);

  /**
   * @summary this handles the dependencies between filters of a category. It updates the part config if a part
   * in another filter is not available after selecting part in another filter.
   * */
  if (selectedCategory === 'bikeArt' && partsConfig.bikeArt) {
    const models = availableCustomizations.bikeArt
      .filter(cust => cust.customizationType === 'model')
      .map(entry => entry.partId);
    const selectedModel = Object.keys(partsConfig.bikeArt).find(key => {
      return models.includes(key) && partsConfig.bikeArt[key] === true;
    });

    const selectedModelCust = availableCustomizations.bikeArt.filter(
      part => part.partId === selectedModel
    )[0];
    const colors = availableCustomizations.bikeArt
      .filter(cust => cust.customizationType === 'color')
      .map(entry => entry.partId);
    const selectedColor = Object.keys(partsConfig.bikeArt).find(key => {
      return colors.includes(key) && partsConfig.bikeArt[key] === true;
    });
    const selectedColorCust = availableCustomizations.bikeArt.filter(
      part => part.partId === selectedColor
    )[0];
    const angles = availableCustomizations.bikeArt
      .filter(cust => cust.customizationType === 'angle')
      .map(entry => entry.partId);

    const viewCode = currentActiveParent === 'front' ? 'F' : 'B';

    const selectedAngleFront = Object.keys(partsConfig.bikeArt).find(
      key =>
        angles.includes(key) &&
        key[key.length - 1] === 'F' &&
        partsConfig.bikeArt[key] === true
    );

    const selectedAngleBack = Object.keys(partsConfig.bikeArt).find(
      key =>
        angles.includes(key) &&
        key[key.length - 1] === 'B' &&
        partsConfig.bikeArt[key] === true
    );

    const selectedNumberPlateBack = availableCustomizations.bikeArt.filter(
      entry =>
        entry.partId.match(/BN\d{4}B/i) &&
        partsConfig.bikeArt[entry.partId] === true
    )[0];

    const selectedNumberPlateFront = availableCustomizations.bikeArt.filter(
      entry =>
        entry.partId.match(/BN\d{4}F/i) &&
        partsConfig.bikeArt[entry.partId] === true
    )[0];

    const selectedBikeTextBack = availableCustomizations.bikeArt.filter(
      entry =>
        entry.customizationType === 'placememt' &&
        partsConfig.bikeArt[entry.partId] === true
    )[0];

    let availableColor = {};
    let availbleAngleFront = {};
    let availbleAngleBack = {};

    newConfig.config.bikeArt = partsConfig.bikeArt;

    /**
     * as soon as a model is selected, availble color is also calculated and selected
     */
    if (
      (selectedModel && !selectedColor) ||
      (selectedModel &&
        !selectedColorCust.dependencies.parts.includes(selectedModel))
    ) {
      availableColor = availableCustomizations.bikeArt
        .filter(cust => cust.customizationType === 'color')
        .find(entry => entry.dependencies.parts.includes(selectedModel));
      if (selectedColor) {
        newConfig.config.bikeArt[selectedColor] = false;
      }
      newConfig.config.bikeArt[availableColor.partId] = true;
    }

    /**
     * as soon as a color is selected, availble angle is also calculated based on that color and model and then selected
     */
    if (
      currentActiveParent === 'front' &&
      (!selectedAngleFront ||
        // (selectedAngleFront && selectedAngleFront[selectedAngleFront.length - 1] !== viewCode) ||
        (selectedModel &&
          !selectedModelCust.secondaryDependencies[
            availableColor.partId || selectedColor
          ].includes(selectedAngleFront)))
    ) {
      const color = availableColor.partId || selectedColor;
      availbleAngleFront = availableCustomizations.bikeArt
        .filter(cust => cust.customizationType === 'angle')
        .sort(compare)
        .find(entry => {
          return (
            selectedModelCust &&
            entry.partId[entry.partId.length - 1] === viewCode && // for bike angle, availble parts also depend on parent category. hence extra check here
            selectedModelCust.secondaryDependencies[color].includes(
              entry.partId
            )
          );
        });
      if (
        selectedAngleFront
        // selectedAngle[selectedAngle.length - 1] === viewCode
      ) {
        newConfig.config.bikeArt[selectedAngleFront] = false;
      }
      newConfig.config.bikeArt[availbleAngleFront.partId] = true;
      const { changedConfig, oldCategory, shouldContinue } = updateCategories(
        allCategories,
        availbleAngleFront,
        availableCategories,
        availableCustomizations,
        shoulReapplyCustomization,
        currentActiveParent,
        selectedCategory,
        partsConfig
      );
      newConfig.config = { ...newConfig.config, ...changedConfig };
      newConfig.oldCategory = oldCategory;
      newConfig.shouldContinue = shouldContinue;
    }

    if (
      currentActiveParent === 'back' &&
      (!selectedAngleBack ||
        // (selectedAngleFront && selectedAngleFront[selectedAngleFront.length - 1] !== viewCode) ||
        (selectedModel &&
          !selectedModelCust.secondaryDependencies[
            availableColor.partId || selectedColor
          ].includes(selectedAngleBack)))
    ) {
      const color = availableColor.partId || selectedColor;
      availbleAngleBack = availableCustomizations.bikeArt
        .filter(cust => cust.customizationType === 'angle')
        .sort(compare)
        .find(entry => {
          return (
            selectedModelCust &&
            entry.partId[entry.partId.length - 1] === viewCode && // for bike angle, availble parts also depend on parent category. hence extra check here
            selectedModelCust.secondaryDependencies[color].includes(
              entry.partId
            )
          );
        });
      if (
        selectedAngleBack
        // selectedAngle[selectedAngle.length - 1] === viewCode
      ) {
        newConfig.config.bikeArt[selectedAngleBack] = false;
      }
      newConfig.config.bikeArt[availbleAngleBack.partId] = true;
      const { changedConfig, oldCategory, shouldContinue } = updateCategories(
        allCategories,
        availbleAngleBack,
        availableCategories,
        availableCustomizations,
        shoulReapplyCustomization,
        currentActiveParent,
        selectedCategory,
        partsConfig
      );
      newConfig.config = { ...newConfig.config, ...changedConfig };
      newConfig.oldCategory = oldCategory;
      newConfig.shouldContinue = shouldContinue;
    }

    if (
      !selectedNumberPlateBack ||
      (currentActiveParent === 'back' &&
        !selectedNumberPlateBack.dependencies.parts.includes(
          availbleAngleBack.partId || selectedAngleBack
        ))
    ) {
      const angle = availbleAngleBack.partId || selectedAngleBack;
      const availableNumberPlate = availableCustomizations.bikeArt
        .filter(cust => cust.partId.match(/BN\d{4}[F|B]/i))
        .find(
          entry =>
            entry.partId[entry.partId.length - 1] === 'B' &&
            entry.dependencies.parts.includes(angle)
        );
      if (selectedNumberPlateBack) {
        newConfig.config.bikeArt[selectedNumberPlateBack.partId] = false;
      }
      if (availableNumberPlate)
        newConfig.config.bikeArt[availableNumberPlate.partId] = true;
    }

    if (
      !selectedNumberPlateFront ||
      (currentActiveParent === 'front' &&
        !selectedNumberPlateFront.dependencies.parts.includes(
          availbleAngleFront.partId || selectedAngleFront
        ))
    ) {
      const angle = availbleAngleFront.partId || selectedAngleFront;
      const availableNumberPlate = availableCustomizations.bikeArt
        .filter(cust => cust.partId.match(/BN\d{4}[F|B]/i))
        .find(
          entry =>
            entry.partId[entry.partId.length - 1] === 'F' &&
            entry.dependencies.parts.includes(angle)
        );
      if (selectedNumberPlateFront) {
        newConfig.config.bikeArt[selectedNumberPlateFront.partId] = false;
      }
      if (availableNumberPlate)
        newConfig.config.bikeArt[availableNumberPlate.partId] = true;
    }

    // if (selectedBikeTextFront && currentActiveParent === 'front') {
    //   const availableNumberPlate = availableCustomizations.bikeArt.filter(
    //     cust =>
    //       cust.partId.match(/TXT\d{3}F/i) &&
    //       cust.partId[cust.partId.length - 1] === 'F'
    //   );
    //   if (selectedBikeTextFront) {
    //     newConfig.config.bikeArt[selectedBikeTextFront.partId] = false;
    //   }
    //   newConfig.config.bikeArt[availableNumberPlate.partId] = true;
    // }

    // if (!selectedBikeTextBack && currentActiveParent === 'back') {
    //   const availableNumberPlate = availableCustomizations.bikeArt.filter(
    //     cust => cust.customizationType === 'placement'
    //   )[0];
    //   if (selectedBikeTextBack) {
    //     newConfig.config.bikeArt[selectedBikeTextBack.partId] = false;
    //   }
    //   newConfig.config.bikeArt[availableNumberPlate.partId] = true;
    // }
  }

  [
    ...availableCategories.filter(
      category =>
        category.categoryType !== 'subCategory' && category.name !== 'sleeve'
    ),
    { name: 'logo' }
  ].forEach(category => {
    const catName = category.name;

    if (
      partsConfig[catName] &&
      catName !== selectedCategory &&
      !allSubCategories.includes(selectedCategory)
    ) {
      const selectedOptionInCategory = Object.keys(partsConfig[catName]).find(
        key => partsConfig[catName][key] === true
      );
      if (selectedOptionInCategory || catName === 'logo') {
        if (categoriesWithSecondaryDep.includes(catName)) {
          const selectedOptionCustomization = availableCustomizations[
            catName
          ].filter(option => option.partId === selectedOptionInCategory)[0];

          let selectedPartDependencies = null;
          if (selectedOptionCustomization) {
            selectedPartDependencies =
              selectedOptionCustomization.dependencies.parts;
          }

          let dependentCategory = 'decal';
          let baseCategory = 'baseColor';

          if (selectedPartDependencies && selectedPartDependencies.length > 0) {
            baseCategory = Object.keys(regexes).find(key =>
              selectedPartDependencies.some(part => regexes[key].test(part))
            );
            const baseCategoryCustomisation =
              availableCustomizations[baseCategory][0];

            dependentCategory = Object.keys(regexes).find(key =>
              regexes[key].test(
                Object.keys(baseCategoryCustomisation.secondaryDependencies)[0]
              )
            );
          }

          const selectedBaseCategoryOption = Object.keys(
            partsConfig[baseCategory]
          ).find(key => partsConfig[baseCategory][key] === true);

          const selectedBaseCategoryCustomisation = availableCustomizations[
            baseCategory
          ].filter(option => option.partId === selectedBaseCategoryOption)[0];

          // let selectedDecalPartId = Object.keys(partsConfig.decal).find(
          //   key => partsConfig.decal[key] === true
          // );

          let dependentCatPartId = Object.keys(partsConfig.decal).find(
            key => partsConfig[dependentCategory][key] === true
          );

          if (dependentCategory === 'decal' && !dependentCatPartId) {
            dependentCatPartId = extraDecalPartIds[selectedVariant];
          }

          const whitelist =
            selectedBaseCategoryCustomisation.secondaryDependencies[
              dependentCatPartId
            ];
          console.log(
            selectedBaseCategoryCustomisation,
            dependentCatPartId,
            'whitelust'
          );
          if (!whitelist.includes(selectedOptionInCategory)) {
            const availablePart = availableCustomizations[catName].find(entry =>
              whitelist.includes(entry.partId)
            );
            if (availablePart) {
              let secondAvailablePart = null;
              if (catName === 'logo') {
                const availableLogos = availableCustomizations[
                  catName
                ].filter(entry => whitelist.includes(entry.partId));
                if (availableLogos.length > 1)
                  secondAvailablePart = availableLogos[1];
              }

              const {
                config,
                newAvailableCategories,
                shouldContinue,
                oldCategory
              } = findAndSelectAvailablePart(
                availableCustomizations,
                catName,
                allCategories,
                selectedOptionInCategory,
                partsConfig,
                availablePart,
                availableCategories,
                shoulReapplyCustomization,
                selectedVariant,
                secondAvailablePart,
                currentActiveParent,
                selectedCategory
              );

              newConfig.config = {
                ...newConfig.config,
                ...config
              };
              newConfig.shouldContinue =
                newConfig.shouldContinue && shouldContinue;
              newConfig.oldCategory = oldCategory;
              // newConfig.availableCategories = newAvailableCategories;
              categoriesAfterSecDeps = newAvailableCategories;
            } else if (catName === 'logo') {
              // for unavailable special categories , if no part available turn all to false
              const config = {};
              Object.keys(partsConfig.logo).forEach(key => {
                config[key] = false;
              });
              newConfig.config = {
                ...newConfig.config,
                logo: config
              };
            }
          } else {
            // whitelist includes the selected logo, but that doesnt stop here. the other selected logo,if any, also needs to be checked
            // the second logo might not be available for the next decal
            if (catName === 'logo') {
              const selectedColorId = Object.keys(partsConfig.baseColor).find(
                x => partsConfig.baseColor[x] === true
              );
              const selectedDecalId = Object.keys(partsConfig.decal).find(
                x => partsConfig.decal[x] === true
              );
              const selectedColor = availableCustomizations.baseColor.find(
                x => x.partId == selectedColorId
              );
              const secDeps =
                selectedColor.secondaryDependencies[selectedDecalId];
              const config = {};
              Object.keys(partsConfig.logo).forEach(key => {
                config[key] = false;
              });

              availableCustomizations[catName].forEach(entry => {
                if (secDeps.includes(entry.partId)) {
                  config[entry.partId] = true;
                }
              });
              newConfig.config = {
                ...newConfig.config,
                logo: config
              };
            }
          }
        } else {
          const selectedOptionCustomization = availableCustomizations[
            catName
          ].filter(option => option.partId === selectedOptionInCategory)[0];

          const selectedPartDependencies =
            selectedOptionCustomization.dependencies.parts;

          const selectedPartCollisions =
            selectedOptionCustomization.collisions.parts;

          let dependentCategory = null;
          let collidingCategory = null;

          if (selectedPartDependencies.length > 0) {
            dependentCategory = Object.keys(regexes).find(key =>
              selectedPartDependencies.some(part => regexes[key].test(part))
            );
          }

          if (selectedPartCollisions.length > 0) {
            collidingCategory = Object.keys(regexes).find(key =>
              selectedPartCollisions.some(part => regexes[key].test(part))
            );
          }

          if (
            (selectedPartDependencies.length > 0 && dependentCategory) ||
            (selectedPartCollisions.length > 0 && collidingCategory) // for now only accounts for dependency on one category
            // dependency on base category (color)
          ) {
            let selectedOptionInDependentCat;
            if (selectedPartDependencies.length > 0) {
              selectedOptionInDependentCat = Object.keys(
                partsConfig[dependentCategory]
              ).find(key => partsConfig[dependentCategory][key] === true);
            }

            let selectedOptionInCollidingCat;
            if (selectedPartCollisions.length > 0) {
              selectedOptionInCollidingCat = Object.keys(
                partsConfig[collidingCategory]
              ).find(key => partsConfig[collidingCategory][key] === true);
            }

            if (
              (selectedOptionInDependentCat &&
                !selectedPartDependencies.includes(
                  selectedOptionInDependentCat
                )) ||
              (selectedOptionInCollidingCat &&
                selectedPartCollisions.includes(selectedOptionInCollidingCat))
            ) {
              const availableDecalsForOption = availableCustomizations.decal.filter(
                entry => entry.dependencies.parts.includes(selectedPart.partId)
              );
              if (catName === 'decal' && !shoulReapplyCustomization) {
                // not available anymore throw prompt
                // newConfig.shouldContinue = false;
                // return;
                if (
                  selectedOptionCustomization.customizationType !== 'mlg' ||
                  (selectedOptionCustomization.customizationType === 'mlg' &&
                    !availableDecalsForOption.find(
                      cust => cust.customizationType === 'mlg'
                    ))
                ) {
                  newConfig.shouldContinue = false;
                }
              }
              let availablePart = checkForAvailablePart(
                availableCustomizations,
                catName,
                selectedOptionInDependentCat,
                selectedOptionInCollidingCat,
                regexes[dependentCategory],
                regexes[collidingCategory]
              );
              if (
                catName === 'decal' &&
                selectedOptionCustomization.customizationType === 'mlg' &&
                availableDecalsForOption.find(
                  cust => cust.customizationType === 'mlg'
                )
              ) {
                availablePart = availableDecalsForOption.find(
                  cust => cust.customizationType === 'mlg'
                );
              }
              const {
                config,
                newAvailableCategories,
                shouldContinue,
                oldCategory
              } = findAndSelectAvailablePart(
                availableCustomizations,
                catName,
                allCategories,
                selectedOptionInCategory,
                partsConfig,
                availablePart,
                availableCategories,
                shoulReapplyCustomization,
                selectedVariant,
                currentActiveParent,
                selectedCategory
              );

              newConfig.config = {
                ...newConfig.config,
                ...config
              };
              newConfig.shouldContinue =
                newConfig.shouldContinue && shouldContinue;
              newConfig.oldCategory = oldCategory;
              categoriesAfterDeps = newAvailableCategories;
            }
          }
        }
      }
    }
  });
  const newAvailableCategories = compareAndCreateNewCategories(
    availableCategories,
    categoriesAfterDeps,
    categoriesAfterSecDeps
  );
  newConfig.availableCategories = newAvailableCategories;
  return newConfig;
};

const checkForCategoryCollisionAndDep = (
  selectedPart,
  availableCategories,
  availableCustomizations,
  shoulReapplyCustomization,
  allCategories,
  currentActiveParent,
  selectedCategory,
  partsConfig
) => {
  const collidingCategoryNames = selectedPart.collisions.category;
  const dependentCategoryNames = selectedPart.dependencies.category;

  const updatedCategories = {
    added: [],
    removed: [],
    changedConfig: {},
    shouldContinue: true,
    oldCategory: null
  };

  const allSubCategories = allCategories
    .filter(cat => cat.categoryType === 'subCategory')
    .map(cat => cat.name);

  if (dependentCategoryNames && dependentCategoryNames.length > 0) {
    dependentCategoryNames.forEach(cat => {
      if (!availableCategories.map(category => category.name).includes(cat)) {
        if (!allSubCategories.includes(cat)) updatedCategories.added.push(cat);
        const allPartsForAddedCategory = getAllPartsForCategory(
          availableCustomizations,
          cat
        );

        const config = {};
        allPartsForAddedCategory.forEach((item, i) => {
          config[item] = i === 0 && cat !== 'goggle';
        });
        updatedCategories.changedConfig = {
          ...updatedCategories.changedConfig,
          [cat]: config
        };
      }
    });
  }
  if (collidingCategoryNames && collidingCategoryNames.length > 0) {
    collidingCategoryNames.forEach(cat => {
      const viewCode = currentActiveParent === 'front' ? 'F' : 'B';
      if (partsConfig[cat]) {
        let selectedPartInCollidingCat = Object.keys(partsConfig[cat]).find(
          key => partsConfig[cat][key] === true
        );
        if (cat === 'bikeArt') {
          selectedPartInCollidingCat = Object.keys(partsConfig[cat]).find(
            key =>
              key[key.length - 1] === viewCode && partsConfig[cat][key] === true
          );
        }
        if (
          ((availableCategories
            .map(category => category.name)
            .includes('decal') &&
            cat === 'decal') ||
            (allSubCategories.includes(cat) && selectedPartInCollidingCat)) &&
          !shoulReapplyCustomization
        ) {
          updatedCategories.shouldContinue = false;
          updatedCategories.oldCategory = cat;
        }
      }
      if (availableCategories.map(category => category.name).includes(cat)) {
        if (!allSubCategories.includes(cat))
          updatedCategories.removed.push(cat);

        const allPartsForRemovedCategory = getAllPartsForCategory(
          availableCustomizations,
          cat
        );
        const config = {};

        let parts = allPartsForRemovedCategory;

        if (cat === 'bikeArt') {
          parts = allPartsForRemovedCategory.filter(
            entry => entry[entry.length - 1] === viewCode
          );
          // turn only parts for current parent to false as back bike art has differenyt collisions
          // from front bike art
        }
        parts.forEach(item => {
          config[item] = false;
        });
        updatedCategories.changedConfig = {
          ...updatedCategories.changedConfig,
          [cat]: { ...partsConfig[cat], ...config }
        };
      }
    });
  }
  return updatedCategories;
};

const getAllPartsForCategory = (availableCustomizations, category) => {
  if (category === 'hotspots') {
    return availableHotspots;
  }
  if (category === 'frontBadge' || category === 'sleeve') {
    const config = [];
    // parts should have updated part ids appendedd with position
    availableCustomizations[category].forEach(item => {
      availableHotspots
        .filter(
          part =>
            (category === 'frontBadge' && !part.includes('S')) ||
            (category === 'sleeve' && part.includes('S'))
        )
        .forEach(hotspot => {
          const partId =
            item.partId.length === 4
              ? hotspot.substring(1, 3) + item.partId
              : item.partId.replace(
                  item.partId.substring(0, 2),
                  hotspot.substring(1, 3)
                );
          config.push(partId);
        });
    });
    return config;
  }

  return availableCustomizations[category]
    .map(item => item.partId)
    .filter(part => part !== null);
};

const getStateAfterSelection = (state, action) => {
  const selectedPart = action.data;
  const { ignoredList } = action;
  if (selectedPart) {
    const {
      partsConfig,
      availableCustomizations,
      availableVariants,
      availableCategories,
      selectedVariant,
      reapplyCustomization,
      currentActiveParent
    } = { ...state };

    const selectedCategory = action.category || state.selectedCategory;
    const isInitialLoad = action.isInitialLoad || false;
    const categoryConfig = {};
    let newUndoStack = [...state.undoStack];

    if (
      (action.category !== 'hotspots' &&
        action.category !== 'bikeArt' &&
        action.category !== 'backText') ||
      (action.category === 'bikeArt' &&
        selectedPart.customizationType !== '') ||
      (action.category === 'backText' &&
        !state.undoStack.map(option => option.name).includes(selectedPart.name))
    ) {
      newUndoStack = [
        {
          category: selectedCategory,
          data: { ...partsConfig },
          availableCategories: [...availableCategories],
          rotateTo: state.rotateTo,
          currentActiveParent: state.currentActiveParent,
          name: selectedPart.name
        },
        ...state.undoStack
      ];
    }

    if (newUndoStack.length > UNDO_STACK_LIMIT) {
      newUndoStack = newUndoStack.slice(0, UNDO_STACK_LIMIT);
    }
    if (
      [
        ...availableCategories.map(cat => cat.name),
        'logo',
        'hotspots'
      ].includes(selectedCategory)
    ) {
      // if it is an available category then select
      let newPartsConfig = { ...partsConfig };
      let secondAvailablePart = null;

      const allPartsForSelectedCategory = getAllPartsForCategory(
        state.availableCustomizations,
        selectedCategory
      );

      // turn all parts of selected category to false which ar enot in ignored list. If ignored list does not exist, turn all to false
      allPartsForSelectedCategory.forEach(item => {
        if (ignoredList) {
          if (!ignoredList.includes(item)) {
            categoryConfig[item] = false;
          } else {
            if (partsConfig[selectedCategory]) {
              categoryConfig[item] = partsConfig[selectedCategory][item];
            }
          }
        } else categoryConfig[item] = false;
      });

      if (selectedCategory === 'logo') {
        // find sec dependency from color and selected decal and add the second logo if any
        const selectedColorId = Object.keys(newPartsConfig.baseColor).find(
          x => newPartsConfig.baseColor[x] === true
        );
        const selectedDecalId = Object.keys(newPartsConfig.decal).find(
          x => newPartsConfig.decal[x] === true
        );
        const selectedColor = availableCustomizations.baseColor.find(
          x => x.partId === selectedColorId
        );
        if (selectedPart.partId) {
          categoryConfig[selectedPart.partId] = true;
        }
        const secDeps = selectedColor.secondaryDependencies[selectedDecalId];
        if (secDeps) {
          secondAvailablePart = availableCustomizations.logo.find(
            x => x.partId !== selectedPart.partId && secDeps.includes(x.partId)
          );
          if (!secDeps.includes(selectedPart.partId)) {
            categoryConfig[selectedPart.partId] = false;
          }
        }
      }

      if (selectedPart.partId && selectedCategory !== 'logo') {
        categoryConfig[selectedPart.partId] = true;
        // set a selecetd part to true, if it was a badge, remove hotspot for that part
        if (
          selectedCategory === 'frontBadge' ||
          selectedCategory === 'sleeve'
        ) {
          newPartsConfig.hotspots[
            `H${selectedPart.partId.substring(0, 2)}001`
          ] = false;
        }
      }

      if (secondAvailablePart)
        categoryConfig[secondAvailablePart.partId] = true;
      newPartsConfig[selectedCategory] = categoryConfig;
      if (selectedCategory !== 'hotspots' && selectedPart.partId) {
        const allCategories =
          availableVariants[selectedVariant].customizationCategories;

        const {
          changedConfig,
          newAvailableCategories,
          shouldContinue,
          oldCategory
        } = updateCategories(
          allCategories,
          selectedPart,
          availableCategories,
          availableCustomizations,
          reapplyCustomization.shouldApply,
          currentActiveParent,
          selectedCategory,
          newPartsConfig
        );

        newPartsConfig = { ...newPartsConfig, ...changedConfig };

        const newConfig = checkForPartsCollisionAndDep(
          selectedPart,
          selectedCategory,
          newPartsConfig,
          allCategories,
          availableCustomizations,
          newAvailableCategories,
          reapplyCustomization.shouldApply,
          selectedVariant,
          currentActiveParent
        );

        if ((newConfig.shouldContinue && shouldContinue) || isInitialLoad) {
          let viewData = {};
          // if(selectedOption.configData.defaultView){
          viewData = {
            rotateTo: selectedPart.configData.defaultView || 'none'
          };
          // }
          return {
            ...state,
            partsConfig: {
              ...newPartsConfig,
              ...newConfig.config
            },
            availableCategories: newConfig.availableCategories,
            undoStack: newUndoStack,
            reapplyCustomization: {
              shouldApply: false,
              selectedPart,
              oldCategory: null,
              newCategory: null,
              ignoredList: null
            },
            ...viewData
          };
        }

        return {
          ...state,
          reapplyCustomization: {
            shouldApply: true,
            selectedPart,
            oldCategory:
              oldCategory ||
              (newConfig.oldCategory ? newConfig.oldCategory : null),
            newCategory: selectedCategory,
            ignoredList
          }
        };
      }
      return {
        ...state,
        partsConfig: {
          ...newPartsConfig
        }
      };
    }
    return state;
  }
  return state;
};

// const getStateAfterIndividualOptionSelection = (state, action) => {
//   const selectedOption = action.data;
//   if (selectedOption) {
//     const currentCategory = action.category || state.selectedCategory;
//     const modifiedState = getCategoriesAfterFiltering(
//       state,
//       selectedOption,
//       currentCategory
//     );

//     if (currentCategory === 'helmetType') return modifiedState;
//     let newUndoStack = [
//       {
//         category: currentCategory,
//         data: state.partsConfig,
//         rotateTo: state.rotateTo
//       },
//       ...state.undoStack
//     ];
//     if (newUndoStack.length > UNDO_STACK_LIMIT) {
//       newUndoStack = newUndoStack.slice(0, UNDO_STACK_LIMIT);
//     }
//     let viewData = {};
//     // if(selectedOption.configData.defaultView){
//     viewData = { rotateTo: selectedOption.configData.defaultView || 'none' };
//     // }
//     return {
//       ...state,
//       partsConfig: {
//         ...state.partsConfig,
//         // [currentCategory]: { ...newPartConfigData },
//         ...modifiedState.changedPartsConfig
//       },
//       availableCategories: modifiedState.availableCategories,
//       currentSelection: { category: currentCategory, data: action.data },
//       undoStack: newUndoStack,
//       ...viewData
//     };
//   }
//   return {
//     ...state
//   };
// };

const getStateAfterTurningPartIdsOff = (state, action) => {
  const selectedCategory = action.category || state.selectedCategory;
  let allPartsForCategory;
  if (state.availableCustomizations[selectedCategory]) {
    let parts = getAllPartsForCategory(
      state.availableCustomizations,
      selectedCategory
    );
    if (selectedCategory === 'bikeArt') {
      const viewCode = state.currentActiveParent === 'front' ? 'F' : 'B';
      const bikeFilteredParts = parts.filter(
        entry => entry[entry.length - 1] === viewCode
      );
      parts = bikeFilteredParts;
    }
    allPartsForCategory = parts;
  } else {
    allPartsForCategory = availableHotspots;
  }
  const newPartConfigData = {};
  allPartsForCategory.forEach(item => {
    newPartConfigData[item] = false;
  });

  return {
    ...state,
    partsConfig: {
      ...state.partsConfig,
      [selectedCategory]: {
        ...state.partsConfig[selectedCategory],
        ...newPartConfigData
      }
    }
  };
};

const getStateAfterPushingToUndoStack = (state, action) => {
  let newUndoStack = action.data ? [action.data, ...state.undoStack] : [];
  if (newUndoStack.length > UNDO_STACK_LIMIT)
    newUndoStack = newUndoStack.slice(0, UNDO_STACK_LIMIT);
  return { ...state, undoStack: newUndoStack };
};

const getStateAfterPushingToRedoStack = (state, action) => {
  let newRedoStack = action.data ? [action.data, ...state.redoStack] : [];
  if (newRedoStack.length > UNDO_STACK_LIMIT)
    newRedoStack = newRedoStack.slice(0, UNDO_STACK_LIMIT);
  return { ...state, redoStack: newRedoStack };
};

const getStateAfterUndo = (state, action) => {
  const undoStack = [...state.undoStack];
  const poppedItem = undoStack[0];

  // const newUserConfigData = poppedItem;
  let newRedoStack = [state.currentSelection, ...state.redoStack];
  const newUndoStack =
    state.undoStack.length > 1 ? state.undoStack.slice(1) : [];
  if (newRedoStack.length > UNDO_STACK_LIMIT) {
    newRedoStack = newRedoStack.slice(0, UNDO_STACK_LIMIT);
  }
  // apply the customization
  const modifiedState = getStateAfterSelection(state, {
    category: poppedItem.category,
    data: poppedItem.data
  });
  return {
    ...modifiedState,
    undoStack: newUndoStack,
    redoStack: newRedoStack,
    selectedCategory: poppedItem.category
    // partsConfig: newUserConfigData
  };
};

// const getStateAfterRedo = state => {
//   const redoConfig = state.redoStack[0];
//   // const newUserConfigData = redoConfig;
//   let newUndoStack = [state.currentSelection, ...state.undoStack];
//   if (newUndoStack.length > 2) {
//     newUndoStack = newUndoStack.slice(0, 2);
//   }
//   const newRedoStack =
//     state.redoStack.length > 1 ? state.redoStack.slice(1) : [];
//   const modifiedState = getStateAfterIndividualOptionSelection(state, {
//     category: redoConfig.category,
//     data: redoConfig.data
//   });
//   return {
//     ...modifiedState,
//     undoStack: newUndoStack,
//     redoStack: newRedoStack,
//     selectedCategory: redoConfig.category
//     // partsConfig: newUserConfigData
//   };
// };

/**
 * Main undo function
 * @param {object} state
 */
const getStateAfterUndoCustomization = state => {
  // saves whole part config in data, instead of individual selection
  const undoStack = [...state.undoStack];
  const newUserConfigData = undoStack[0];
  let newRedoStack = [
    {
      category: state.selectedCategory,
      data: state.partsConfig,
      rotateTo: state.rotateTo,
      availableCategories: [...state.availableCategories],
      currentActiveParent: state.currentActiveParent,
      name: newUserConfigData.name
    },
    ...state.redoStack
  ];

  const newUndoStack =
    state.undoStack.length > 1 ? state.undoStack.slice(1) : [];
  if (newRedoStack.length > 2) {
    newRedoStack = newRedoStack.slice(0, 2);
  }
  if (['frontBadge', 'sleeve'].includes(newUserConfigData.category)) {
    Object.keys(newUserConfigData.data.hotspots).forEach(x => {
      // need to handle based on badge type. front badge will turn on respective meshes
      const activeBadgeAtX = Object.keys(
        newUserConfigData.data[newUserConfigData.category]
      ).find(
        key =>
          key.substring(0, 2) === x.substring(1, 3) &&
          newUserConfigData.data[newUserConfigData.category][key] === true
      );
      if (
        ((newUserConfigData.category === 'sleeve' && x.includes('S')) ||
          (newUserConfigData.category === 'frontBadge' && !x.includes('S'))) &&
        !newUserConfigData.data.hotspots[x] &&
        !activeBadgeAtX
      )
        newUserConfigData.data.hotspots[x] = true;
    });
    // const partConfigForCategory =
    //   newUserConfigData.data[newUserConfigData.category];
    // const nonSelectedBadges = Object.keys(partConfigForCategory).filter(
    //   x => partConfigForCategory[x] === true
    // );
    // if (trueParts.length > 0) {
    //   Object.keys(newUserConfigData.data.hotspots).forEach(x => {
    //     // need to handle based on badge type. front badge will turn on respective meshes
    //     newUserConfigData.data.hotspots[x] = true;
    //   });
    // }
  }

  let selectedCategory = newUserConfigData.category;
  if (newUserConfigData.currentActiveParent) {
    const { childCategories } = newUserConfigData.availableCategories.filter(
      cat => cat.name === newUserConfigData.currentActiveParent
    )[0];

    selectedCategory = childCategories.filter(cat =>
      Object.keys(newUserConfigData.data[cat]).find(
        key => newUserConfigData.data[cat][key] === true
      )
    )[0];
  }

  return {
    ...state,
    undoStack: newUndoStack,
    redoStack: newRedoStack,
    partsConfig: newUserConfigData.data,
    selectedCategory,
    rotateTo: newUserConfigData.rotateTo,
    availableCategories: newUserConfigData.availableCategories,
    currentActiveParent: newUserConfigData.currentActiveParent
  };
};
const getStateAfterRedoCustomization = state => {
  // saves whole part config in data, instead of individual selection
  const newUserConfigData = state.redoStack[0];
  let newUndoStack = [
    {
      category: state.selectedCategory,
      data: state.partsConfig,
      rotateTo: state.rotateTo,
      availableCategories: [...state.availableCategories],
      currentActiveParent: state.currentActiveParent
    },
    ...state.undoStack
  ];

  if (newUndoStack.length > 2) {
    newUndoStack = newUndoStack.slice(0, 2);
  }
  const newRedoStack =
    state.redoStack.length > 1 ? state.redoStack.slice(1) : [];
  return {
    ...state,
    undoStack: newUndoStack,
    redoStack: newRedoStack,
    partsConfig: newUserConfigData.data,
    selectedCategory: newUserConfigData.category,
    rotateTo: newUserConfigData.rotateTo,
    availableCategories: newUserConfigData.availableCategories,
    currentActiveParent: newUserConfigData.currentActiveParent
  };
};

export const populateAllAvailableCustomizations = (
  variantId,
  allCategories
) => async dispatch => {
  try {
    const response = await axios.get(`customizations/variants/${variantId}`);
    const availableCustomizations = response.data;
    dispatch(setAvailableCustomizations(availableCustomizations));
    Object.keys(availableCustomizations).forEach(category => {
      // if (!['goggle', 'logo', 'isi', 'visorColor'].includes(category))
      if (!['goggle', 'isi'].includes(category)) {
        // (category !== "goggle")
        const currentCategory = allCategories.filter(
          cat => cat.name === category
        )[0];
        if (
          category === 'logo' ||
          !currentCategory.childCategories ||
          (currentCategory.childCategories &&
            currentCategory.childCategories.length === 0)
        ) {
          let selectedPart =
            (category !== 'logo' &&
              currentCategory.categoryType === 'subCategory') ||
            category === 'sleeve'
              ? {}
              : availableCustomizations[category][0];
          // if(category === 'decal') {
          //   selectedPart = Object.keys(availableCustomizations.baseColor[0].secondaryDependencies)[0]
          // }
          dispatch(updatePartsConfig(selectedPart, category, [], true));
        }
      }
      // adding for urbanTrooper where there is no supporting category to turn populate goggles initially
      if (category === 'goggle') {
        // populate parts config with goggle data and set all to false. (later if we have more goggles with tints or colors)
        dispatch(removePartConfig('goggle')); // ?? this action apparently set goggles to false. must be renamed
      }
    });
    dispatch(setIsDataReady(true));
    dispatch(pushToUndoStack());
    dispatch(pushToRedoStack());
  } catch (err) {
    console.error(err.stack);
  }
};

export const getAccessoryVariantData = variantId => async dispatch => {
  try {
    const accessoryData = await axios.get(
      `accessoryTypes/variant/${variantId}`
    );

    dispatch(setUserConfigId(null));
    // should set "availableVariants" above
    // batch(() => {
    const config = {};
    if (variantId === 'TShirt') {
      dispatch(setIsLoading(true));
      const hotspots = {};
      availableHotspots.forEach(part => {
        hotspots[part] = false;
      });
      config.hotspots = hotspots;
    }
    dispatch(populateAllPartsConfig(config));
    dispatch(setSelectedVariant(variantId));
    dispatch(setAvailableVariants(variantId, accessoryData.data));
    dispatch(
      setAvailableCategories(
        accessoryData.data.customizationCategories.filter(i => i !== 0)
      )
    );
    dispatch(
      populateAllAvailableCustomizations(
        variantId,
        accessoryData.data.customizationCategories
      )
    );
    // });
  } catch (err) {
    console.error(err);
    dispatch(setIsLoading(false));
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_AVAILABLE_VARIANTS_DATA:
      // set up to allow populating one variant at a time, this will make the data loading async to increase performance
      return {
        ...state,
        availableVariants: {
          ...state.availableVariants,
          [action.variant]: action.data
        }
      };
    case SET_AVAILABLE_CATEGORIES:
      return { ...state, availableCategories: action.data };
    case SET_SELECTED_CATEGORY:
      return {
        ...state,
        selectedCategory: action.category
      };
    case UPDATE_PARTS_CONFIG:
      return getStateAfterSelection(state, action);
    case SET_AVAILABLE_CUSTOMIZATIONS:
      return {
        ...state,
        availableCustomizations: action.data
      };
    case SET_ACTIVE_PARENT:
      return {
        ...state,
        currentActiveParent: action.category
      };
    case POPULATE_ALL_PART_CONFIG:
      return { ...state, partsConfig: action.data };
    case REMOVE_PART_CONFIG:
      return getStateAfterTurningPartIdsOff(state, action);
    case SET_VARIANT_DATA:
      return { ...state, variantData: action.data };
    case SET_IS_DATA_READY:
      return { ...state, isDataReady: action.bool };
    case PUSH_TO_UNDO_STACK:
      return getStateAfterPushingToUndoStack(state, action);
    case PUSH_TO_REDO_STACK:
      return getStateAfterPushingToRedoStack(state, action);
    case UNDO:
      return getStateAfterUndoCustomization(state);
    case SET_SELECTED_VARIANT:
      return { ...state, selectedVariant: action.variant };
    case REDO:
      return getStateAfterRedoCustomization(state);
    case SET_SELECTED_SIZE:
      return { ...state, selectedSize: action.size };
    case SET_CURRENT_TEXT:
      return { ...state, currentText: action.text, rotateTo: action.rotateTo };
    case SET_ACTIVE_HOTSPOT:
      return { ...state, activeHotspot: action.hotspot };
    case SET_FRONT_BIKE_PLATE:
      return {
        ...state,
        tShirtBikeFrontNumberPlate: {
          text: [
            {
              ...state.tShirtBikeFrontNumberPlate.text[0],
              line: action.line,
              fontSize: action.fontSize
            }
          ],
          uOffset: action.uOffset,
          vOffset: action.vOffset,
          quality: 'high',
          width: action.width
        }
      };
    case SET_BACK_BIKE_PLATE:
      return {
        ...state,
        tShirtBikeBackNumberPlate: {
          text: [
            {
              ...state.tShirtBikeBackNumberPlate.text[0],
              line: action.line,
              fontSize: action.fontSize
            }
          ],
          uOffset: action.uOffset,
          vOffset: action.vOffset,
          quality: 'high',
          width: action.width
        }
      };
    case SET_FRONT_BIKE_TEXT:
      return {
        ...state,
        tShirtBikeFrontText: [
          { ...state.tShirtBikeFrontText[0], line: action.line }
        ]
      };
    case SET_BACK_BIKE_TEXT:
      return {
        ...state,
        tShirtBikeBackText: [
          { ...state.tShirtBikeBackText[0], line: action.line }
        ]
      };
    case SET_USER_ID:
      return { ...state, userId: action.userId };
    case SET_SESSION_ID:
      return { ...state, sessionId: action.sessionId };
    case SET_SHOULD_REAPPLY_CUSTOMIZATION:
      return {
        ...state,
        reapplyCustomization: { ...state.reapplyCustomization, ...action.data }
      };
    case SET_USER_CONFIG_ID:
      return { ...state, userConfigId: action.userConfigId };
    case POPULATE_SAVED_USER_CONFIGS:
      return { ...state, savedUserConfigs: action.data };
    case SET_ALERT_DIALOG:
      return {
        ...state,
        alertInfo: { ...state.alertInfo, ...action.alertInfo }
      };
    case SET_SITE_URL:
      return { ...state, siteUrl: action.siteUrl };
    default:
      return state;
  }
};

const sampleData = {
  availableVariants: [
    // will be populated on tab click
    {
      name: 'Open Face',
      variantId: 'OpenFaceHelmet-ObjectId',
      accessoryCategory: 'helmet',
      baseLoadConfig: {},
      customizationCategories: [
        { name: 'decal', accessoryCategory: 'helmet', thumbnail: 'xbjx' },
        { name: 'baseColor', accessoryCategory: 'helmet', thumbnail: 'xbjx' },
        {
          name: 'internalFabricColor',
          accessoryCategory: 'helmet',
          thumbnail: 'xbjx'
        },
        { name: 'visorType', accessoryCategory: 'helmet', thumbnail: 'xbjx' },
        { name: 'visorColor', accessoryCategory: 'helmet', thumbnail: 'xbjx' },
        { name: 'goggles', accessoryCategory: 'helmet', thumbnail: 'xbjx' },
        { name: 'finish', accessoryCategory: 'helmet', thumbnail: 'xbjx' }
      ]
    },
    { name: 'Full Face' },
    { name: 'Urban Trooper' }
  ],
  selectedCustomizationCategoryData: {
    // will be populated on selecting category from wheel
    categoryName: 'decal',
    data: [
      {
        _id: 'xyz122413',
        name: 'Dilli wale',
        thumbnail: '',
        price: '',
        customizationCategoryId: '',
        customizationType: '',
        dependencies: [
          {
            partId: '10002',
            meshVariations: [
              {
                materialId: 'm1002',
                meshId: '123214'
              }
            ],
            isStandard: false
          }
        ],
        parts: [
          {
            partId: '10003',
            meshVariations: [
              {
                materialId: 'm1202',
                meshId: '1232214'
              }
            ],
            isStandard: false
          }
        ]
      }
    ]
  },
  currentUserConfiguration: {
    // can be initialised to default state, or we can populate this dynamically, on category click
    decal: {
      part1: true,
      part2: false,
      part3: false
    },
    baseColor: {},
    internalFabricColor: {}
  },
  flatennedUserConfigData: {}
};

export const useActiveStateSelector = (
  category,
  options,
  partsConfig,
  setActive
) => {
  // useEffect(() => {
  //   const selectedPartId = Object.keys(partsConfig[category]).find(
  //     x => partsConfig[category][x] === true
  //   );
  //   if (selectedPartId) {
  //     if (category === 'goggle') {
  //       // goggle active state is not dependent on index right now. might be a problem if more decals come in
  //       setActive(selectedPartId);
  //     } else {
  //       const index = options.map(x => x.partId).indexOf(selectedPartId);
  //       setActive(index);
  //     }
  //   }
  // }, [partsConfig[category]]);
};
